import React, { useState, useEffect, useContext, useMemo } from 'react'
import Select from "react-select";
import DatePicker from "react-datepicker";
import { Aes256Encrypt, Decrypt_Id_Name, Encrypted_Id_Name, LockFildscolour, Requiredcolour, base64ToString, customStylesWithOutColor, filterPassedTimeZone, filterPassedTimeZonesProperty, getShowingDateText, getShowingMonthDateYear, getYearWithOutDateTime, isLockOrRestrictModule, selectBoxDiableColourStyles, stringToBase64, } from '@/Components/Common/Utility';
import { useLocation, useNavigate } from 'react-router-dom';
import { AddDeleteUpadate, fetchPostData, AddDelete_Img, fetchPostDataNibrs } from '@/Components/hooks/Api';
import { Comman_changeArrayFormat, threeColArray } from '@/Components/Common/ChangeArrayFormat';
import { toastifyError, toastifySuccess } from '@/Components/Common/AlertMsg';
import { AgencyContext } from 'Context/Agency';
import { RequiredFieldIncident, RequiredFieldOnConditon } from '@/Components/Pages/Utility/Personnel/Validation';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import defualtImage from '@/img/uploadImage.png';
import ChangesModal from '@/Components/Common/ChangesModal';
import MasterNameModel from '@/Components/Pages/MasterNameModel/MasterNameModel';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { get_Inc_ReportedDate, get_LocalStoreData } from '@/redux/actions/Agency';
import { MasterVehicle_ID, Vehicle_ID, Classification_Drp_Data, Master_Vehicle_Status } from '@/redux/actionTypes';
import ImageModel from '@/Components/Pages/ImageModel/ImageModel';
import { get_ScreenPermissions_Data } from '@/redux/actions/IncidentAction';
import { get_Data_VODID_Drp_Data, get_AgencyOfficer_Data, get_ArresteeName_Data, get_ModalId_Drp_Data, get_Classification_Drp_Data, get_PlateType_Drp_Data, get_State_Drp_Data, get_VehicleLossCode_Drp_Data, get_Masters_Name_Drp_Data, get_IsPrimary_Color_Drp_Data, get_IsSecondary_Color_Drp_Data, get_ArresteeNameVehicle, get_Masters_PossessionOwnerData } from '@/redux/actions/DropDownsData';
import VehicleSearchTab from '@/Components/Pages/VehicleSearchTab/VehicleSearchTab';
import { get_Vehicle_Search_Data } from '@/redux/actions/VehicleAction';
import ListModal from '@/Components/Pages/Utility/ListManagementModel/ListModal';
import AlertMasterModel from '@/Components/Pages/AlertMaster/AlertMasterModel';
import BarCode from '@/Components/Common/BarCode';
import NirbsErrorShowModal from '@/Components/Common/NirbsErrorShowModal';
import Loader from '@/Components/Common/Loader';
import CurrentVehicleReport from '@/Components/Pages/Vehicle/VehicleTab/Home/CurrentVehicleReport';
import NCICModal from '@/CADComponents/NCICModal';
import { useNibrs } from '@/Context/NIBRS/NibrsLeftTreeContext';

const VEHICLE_CATEGORY_OFFENSE_TOOLTIP_RULES = [
    {
        offenses: ['220', '240'],
        categoryCodes: ['29', '30', '31', '32', '33', '34', '35'],
        message: 'Error - Selected Property/Vehicle category cannot be used with associated offense 220 and 240.',
    },
    {
        offenses: ['23A', '24B'],
        categoryCodes: ['01', '03', '04', '05', '12', '15', '18', '24', '28', '29', '30', '31', '32', '33', '34', '35', '37', '39', '66', '78'],
        message: 'Error - Selected Property/Vehicle category cannot be used with associated offense 23A and 23B.',
    },
    {
        offenses: ['23C'],
        categoryCodes: ['01', '03', '05', '12', '15', '18', '24', '28', '29', '30', '31', '32', '33', '34', '35', '37', '39'],
        message: 'Error - Selected Property/Vehicle category cannot be used with associated offense 23C.',
    },
    {
        offenses: ['23D', '23E', '23F', '23G'],
        categoryCodes: ['03', '05', '24', '28', '29', '30', '31', '32', '33', '34', '35', '37'],
        message: 'Error - Selected Property/Vehicle category cannot be used with associated offense 23D, 23E, 23F and 23G.',
    },
    {
        offenses: ['23H'],
        categoryCodes: ['03', '05', '24', '37'],
        message: 'Error - Selected Property/Vehicle category cannot be used with associated offense 23H.',
    },
];

const Home = ({ setStatus, setShowVehicleRecovered, newStatus, ResetErrors, setResetErrors, showVehicleRecovered, get_List, setPropertyStatus, isCad = false, isViewEventDetails = false, isCADSearch = false, clickCount, isLocked, setIsLocked, isCaseManagement = false, isPropertyEvidence = false, refetchPropertyForCaseManagementData = () => { }, onAfterInsert = null, ListData, setIsNonPropertyRoomSelected, propertystatus, isFormViewOnly = false, selectedPropertyID, selectedMasterPropertyID, selectedIncidentID, releaseSyncedOwner }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { refetchNibrsLeftTreeErrors } = useNibrs();
    const localStoreData = useSelector((state) => state.Agency.localStoreData);
    const incReportedDate = useSelector((state) => state.Agency.incReportedDate);
    const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';
    const effectiveScreenPermission = useSelector((state) => state.Incident.effectiveScreenPermission);
    const vodIdData = useSelector((state) => state.DropDown.vehicleVODIDDrpData);
    const primaryOfficerID = useSelector((state) => state.DropDown.agencyOfficerDrpData)
    const modalIdDrp = useSelector((state) => state.DropDown.modalIdDrpData)
    const classificationID = useSelector((state) => state.DropDown.classificationDrpData)
    const plateTypeIdDrp = useSelector((state) => state.DropDown.vehiclePlateIdDrpData)
    const stateList = useSelector((state) => state.DropDown.stateDrpData);
    const isSecondaryDrpData = useSelector((state) => state.DropDown.isSecondaryDrpData);
    const isPrimaryDrpData = useSelector((state) => state.DropDown.isPrimaryDrpData);
    const arresteeNameVehicle = useSelector((state) => state.DropDown.arresteeNameVehicle);
    const inProfessionOf = useSelector((state) => state.DropDown.arresteeNameData);
    const mastersNameDrpData = useSelector((state) => state.DropDown.mastersNameDrpData);
    const ownerPossessionDrpData = useSelector((state) => state.DropDown.ownerPossessionDrpData);
    const masterVehicleStatus = useSelector((state) => state.Agency.masterVehicleStatus);
    const propertyLossCodeData = useSelector((state) => state.DropDown.vehicleLossCodeDrpData);

    const useQuery = () => {
        const params = new URLSearchParams(useLocation().search);
        return {
            get: (param) => params.get(param)
        };
    };

    const query = useQuery();
    let DecVehId = 0, DecMVehId = 0
    let MstVehicle = query?.get('page');
    var IncID = query?.get("IncId");
    const effectiveIncidentID = selectedIncidentID != null && selectedIncidentID !== '' ? selectedIncidentID : (IncID || 0);
    var IncNo = query?.get("IncNo");
    var IncSta = query?.get("IncSta");
    var VehId = query?.get("VehId");
    var MVehId = query?.get('MVehId');
    var VehSta = query?.get('VehSta');
    let isNew = query?.get('isNew');
    let CaseId = query?.get('CaseId');
    if (!IncID) IncID = 0;
    else IncID = parseInt(base64ToString(IncID));
    if (!VehId) VehId = 0;
    else DecVehId = parseInt(base64ToString(VehId));
    if (!MVehId) VehId = 0;
    else DecMVehId = parseInt(base64ToString(MVehId));


    const { get_vehicle_Count, get_Incident_Count, updateCount, setUpdateCount, incidentCount, nibrsSubmittedStatus, nibrsSubmittedvehicleMain, setnibrsSubmittedvehicleMain, setnibrsSubmittedStatus, changesStatus, changesStatusCount, setChangesStatus, setVehicleStatus, vehicleStatus, VehicleFilterData, get_Data_Vehicle, get_Name_Count, datezone, GetDataTimeZone, setcountoffaduit, validate_IncSideBar, incidentReportedDate, setIncidentReportedDate } = useContext(AgencyContext)

    const [clickedRow, setClickedRow] = useState(null);
    const [destoryDate, setDestoryDate] = useState();
    const [plateExpDate, setPlateExpDate] = useState();
    const [manufactureDate, setManufactureDate] = useState();
    const [inspectionExpDate, setInspectionExpDate] = useState();
    const [categoryIdDrp, setCategoryIdDrp] = useState([]);
    const [lossCode, setLossCode] = useState('');
    const [categoryCode, setCategoryCode] = useState('');
    const [plateTypeCode, setPlateTypeCode] = useState('');
    const [modalStatus, setModalStatus] = useState(false);
    const [nameModalStatus, setNameModalStatus] = useState(false);
    const [masterPropertyID, setMasterPropertyID] = useState('');
    const [editval, setEditval] = useState([]);
    const [vehicleMultiImg, setVehicleMultiImg] = useState([])
    const [imageId, setImageId] = useState('');
    const [mainIncidentID, setMainIncidentID] = useState('');
    const [vehicleID, setVehicleID] = useState('');
    const [loginAgencyID, setLoginAgencyID] = useState('');
    const [loginPinID, setLoginPinID] = useState('');
    const [type, setType] = useState("VehicleOwner");
    const [possessionID, setPossessionID] = useState('');
    const [ownerOfID, setOwnerOfID] = useState('');
    const [possenSinglData, setPossenSinglData] = useState([]);
    const [uploadImgFiles, setuploadImgFiles] = useState([]);
    const [imageModalStatus, setImageModalStatus] = useState(false);
    const [searchModalState, setSearchModalState] = useState();
    const [openPage, setOpenPage] = useState('');
    const [availableAlert, setAvailableAlert] = useState([]);
    const [statesChangeStatus, setStatesChangeStatus] = useState(false);
    const [printStatus, setPrintStatus] = useState(false);
    const [printVehReport, setPrintVehReport] = useState(false);
    const [VehReportCount, setVehReportCount] = useState(1);
    const [openNCICModal, setOpenNCICModal] = useState(false);
    const [vehMakeDrpData, setVehMakeDrpData] = useState([])
    const [styleDrp, setStyleDrpData] = useState([])
    const [baseDate, setBaseDate] = useState('');
    const [oriNumber, setOriNumber] = useState('');
    const [nibrsValidateData, setnibrsValidateData] = useState([]);
    const [nibrsErrStr, setNibrsErrStr] = useState('');
    const [clickNibloder, setclickNibLoder] = useState(false);
    const [nibrsErrModalStatus, setNibrsErrModalStatus] = useState(false);
    const [imageModalOfficerID, SetImageModalOfficerID] = useState(null);
    const [newClicked, SetNewClciked] = useState(0);
    const [vehErrorStatus, setVehErrorStatus] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [recoveredVehicleData, setRecoveredVehicleData] = useState([]);
    const [navigateStatus, SetNavigateStatus] = useState(false);
    const [VehicleIDNCICModal, setVehicleIDNCICModal] = useState('');
    // permissions
    const [permissionForAdd, setPermissionForAdd] = useState(false);
    const [permissionForEdit, setPermissionForEdit] = useState(false);
    const [nibrsCodeArr, setNibrsCodeArr] = useState([]);
    // Add Update Permission
    const [addUpdatePermission, setaddUpdatePermission] = useState();
    const [isVehicleLossCodeFieldHovered, setIsVehicleLossCodeFieldHovered] = useState(false);
    const [isVehicleCategoryFieldHovered, setIsVehicleCategoryFieldHovered] = useState(false);

    const [value, setValue] = useState({
        'IncidentID': '', 'VehicleID': '', 'PropertyID': '', 'MasterPropertyID': '', 'CreatedByUserFK': '',
        'VehicleNumber': 'Auto Generated', 'ReportedDtTm': '', 'LossCodeID': null, 'CategoryID': null, 'PlateID': null,
        'VehicleNo': '', 'PlateTypeID': null, 'ClassificationID': '', 'IsSendToPropertyRoom': '', 'VIN': '', 'VODID': '', 'PlateExpireDtTm': '',
        'OANID': '', 'StyleID': '', 'MakeID': null, 'ModelID': null, 'ManufactureYear': '', 'Weight': '', 'OwnerID': null,
        'PrimaryColorID': '', 'SecondaryColorID': '', 'Value': '', 'Inspection_Sticker': '', 'InspectionExpiresDtTm': '',
        'PrimaryOfficerID': null, 'InProfessionOf': '', 'TagID': null, 'NICBID': null, 'DestroyDtTm': '', 'Description': '',
        'IsEvidence': '', 'IsVehicleImpound': '', 'IsImmobalizationDevice': '', 'IsEligibleForImmobalization': '', 'IsRecoveredByAgencyOfOther': '', 'IsPropertyRecovered': '',
        'UnderJurisdiction': false,
        'ModifiedByUserFK': "", 'ArrestID': "", 'AgencyID': '', 'IsMaster': MstVehicle === "MST-Vehicle-Dash" ? true : false,
        'ModelName': '',
        'PlateExpirationMonth': '',
        'PlateExpirationYear': '',
    });

    const [errors, setErrors] = useState({
        'LossCodeIDError': '', 'CategoryIDError': '', 'RecoveryTypeIDError': '', 'PlateTypeIDError': '', 'VehicleNoError': '', 'vinLengthError': '',
        'PlateStateNoError': '',
        'UnderJurisdictionError': '',
        'RecoveredVehicleDataError': '',
    })

    const isLossCodeNoneOrUnknown = useMemo(() => {
        const selectedLossCode = propertyLossCodeData?.find((item) => item?.value === value?.LossCodeID);
        if (!selectedLossCode) return false;

        const code = String(selectedLossCode?.id || '').trim().toUpperCase();
        const label = String(selectedLossCode?.label || '').trim().toUpperCase();

        return code.includes('NONE') || code.includes('UNKNOWN') || label.includes('NONE') || label.includes('UNKNOWN');
    }, [propertyLossCodeData, value?.LossCodeID]);

    const isRecoveredOrStolenLossCode = (lossCodeID) => {
        if (!lossCodeID) return false;
        const lossCodeObj = propertyLossCodeData?.find((item) => item?.value === lossCodeID);
        const code = String(lossCodeObj?.id || '').trim().toUpperCase();
        return code === 'RECD' || code === 'STOL';
    };

    const isStolenLossCode = (lossCodeID) => {
        if (!lossCodeID) return false;
        const lossCodeObj = propertyLossCodeData?.find((item) => item?.value === lossCodeID);
        const code = String(lossCodeObj?.id || '').trim().toUpperCase();
        return code === 'STOL';
    };

    const isRecoveredLossCode = (lossCodeID) => {
        if (!lossCodeID) return false;
        const lossCodeObj = propertyLossCodeData?.find((item) => item?.value === lossCodeID);
        const code = String(lossCodeObj?.id || '').trim().toUpperCase();
        return code === 'RECD';
    };

    const [imgData, setImgData] = useState({
        "PictureTypeID": '', "ImageViewID": '', "ImgDtTm": '', "OfficerID": '', "Comments": '', "DocumentID": ''
    })

    useEffect(() => {
        if (!localStoreData?.AgencyID || !localStoreData?.PINID) {
            if (uniqueId) dispatch(get_LocalStoreData(uniqueId));
        }
    }, []);

    useEffect(() => {
        if (ResetErrors) {
            reset();
        }
    }, [ResetErrors]);


    useEffect(() => {
        if (localStoreData) {
            setLoginAgencyID(localStoreData?.AgencyID); setLoginPinID(localStoreData?.PINID);
            dispatch(get_ScreenPermissions_Data("V081", localStoreData?.AgencyID, localStoreData?.PINID));
            get_Incident_Count(IncID, localStoreData?.PINID);
            if (!datezone) GetDataTimeZone(localStoreData?.AgencyID);
            setBaseDate(localStoreData?.BaseDate ? localStoreData?.BaseDate : null); setOriNumber(localStoreData?.ORI);
        }
    }, [localStoreData]);

    useEffect(() => {
        if (effectiveScreenPermission?.length > 0) {
            setPermissionForAdd(effectiveScreenPermission[0]?.AddOK);
            setPermissionForEdit(effectiveScreenPermission[0]?.Changeok);
            setaddUpdatePermission(effectiveScreenPermission[0]?.AddOK != 1 || effectiveScreenPermission[0]?.Changeok != 1 ? true : false);
        }
        else {
            setaddUpdatePermission(false);
        }
    }, [effectiveScreenPermission]);

    useEffect(() => {
        if (MstVehicle === "MST-Vehicle-Dash" && masterVehicleStatus === true) {
            newVehicle();
            setPossessionID(''); setOwnerOfID('');
            setPossenSinglData([]);

            // dispatch({ type: Masters_Name_Drp_Data, payload: [] });
        }
    }, [MstVehicle, masterVehicleStatus]);

    useEffect(() => {
        if (value.CategoryID === '' || value.CategoryID === null) {
            setValue({ ...value, ['ClassificationID']: '' });
        }
    }, [value.CategoryID])

    useEffect(() => {
        if (IncID) {
            setMainIncidentID(IncID); get_Data_Vehicle(IncID); dispatch(get_ArresteeNameVehicle('', '', IncID));
            if (!incReportedDate) { dispatch(get_Inc_ReportedDate(IncID)) }
        }
    }, [IncID, nameModalStatus, possessionID, ownerOfID, loginPinID]);

    useEffect(() => {
        if (type === "VehicleName" && possessionID) { setValue({ ...value, ['InProfessionOf']: parseInt(possessionID) }); }
        if (type === "VehicleOwner" && ownerOfID) { setValue({ ...value, ['OwnerID']: parseInt(ownerOfID) }); }
    }, [possessionID, arresteeNameVehicle, ownerOfID, type, mastersNameDrpData, ownerPossessionDrpData]);

    useEffect(() => {
        if (loginAgencyID) {
            const defaultDate = datezone ? new Date(datezone) : null;
            setValue({
                ...value,
                'IncidentID': IncID, 'OfficerID': loginPinID, 'CreatedByUserFK': loginPinID, 'AgencyID': loginAgencyID,
                'PrimaryOfficerID': loginPinID,
                'ReportedDtTm': (MstVehicle !== "MST-Vehicle-Dash" ? (incReportedDate ? getShowingDateText(incReportedDate) : defaultDate) : defaultDate)
            });
            PropertyType(loginAgencyID);
        }
    }, [loginAgencyID, incReportedDate, datezone]);

    useEffect(() => {
        if (loginAgencyID) {
            if (primaryOfficerID?.length === 0) { dispatch(get_AgencyOfficer_Data(loginAgencyID)); }
        }
    }, [loginAgencyID, IncID]);

    useEffect(() => {
        if (DecVehId || DecMVehId) {
            setVehicleID(DecVehId);
            GetSingleData(DecVehId, DecMVehId);
            setMasterPropertyID(DecMVehId);
            MstVehicle == 'MST-Vehicle-Dash' ? get_vehicle_Count(0, DecMVehId) : get_vehicle_Count(DecVehId, DecMVehId)
            get_Data_Vehicle_Offence(DecVehId, DecMVehId, IncID)

        } else {
            if (!DecVehId && !DecMVehId) reset();
        }
    }, [DecVehId, DecMVehId, clickCount]);

    const get_Data_Vehicle_Offence = (propertyID, DecMPropID, mainIncidentID) => {
        const val = { 'PropertyID': propertyID, 'MasterPropertyID': DecMPropID ? DecMPropID : 0, 'IncidentID': mainIncidentID, 'OffenseID': 0, 'IsMaster': false, }
        fetchPostData('PropertyOffense/GetData_PropertyOffense', val).then((res) => {
            if (res) {
                const nibrsCodeArr = res?.map((item) => item?.NIBRSCode);
                setNibrsCodeArr(nibrsCodeArr);
            } else {
                setNibrsCodeArr([])
            }
        });
    }

    const shouldShowUnderJurisdictionRecoverError = useMemo(() => {
        if (!value?.UnderJurisdiction) return false;
        const offenseCodes = Array.isArray(nibrsCodeArr) ? nibrsCodeArr : [];
        return !offenseCodes.includes('280') && !offenseCodes.includes('250');
    }, [value?.UnderJurisdiction, nibrsCodeArr]);

    // When parent (e.g. PropertyVehicleManager) passes selected vehicle IDs, load that vehicle into the form; when both null, clear form
    useEffect(() => {
        if (isPropertyEvidence && selectedPropertyID == null && selectedMasterPropertyID == null) {
            setEditval([]);
            return;
        }
        if (selectedPropertyID != null || selectedMasterPropertyID != null) {
            const propId = selectedPropertyID ?? 0;
            const masterId = selectedMasterPropertyID ?? 0;
            if (propId > 0 || masterId > 0) {
                setVehicleID(propId);
                setMasterPropertyID(masterId);
                GetSingleData(propId, masterId);
            }
        }
    }, [selectedPropertyID, selectedMasterPropertyID, isPropertyEvidence]);

    useEffect(() => {
        if (loginAgencyID) {
            if (isPrimaryDrpData?.length === 0) { dispatch(get_IsPrimary_Color_Drp_Data(loginAgencyID)) };
            if (isSecondaryDrpData?.length === 0) { dispatch(get_IsSecondary_Color_Drp_Data(loginAgencyID)) };
            if (propertyLossCodeData?.length === 0) { dispatch(get_VehicleLossCode_Drp_Data(loginAgencyID)) };
            if (plateTypeIdDrp?.length === 0) { dispatch(get_PlateType_Drp_Data(loginAgencyID)) };
            PropertyType(loginAgencyID);
            if (effectiveIncidentID) { dispatch(get_ArresteeNameVehicle('', '', effectiveIncidentID)) }
            if (effectiveIncidentID) { dispatch(get_ArresteeName_Data('', '', effectiveIncidentID)) }
            if (vodIdData?.length === 0) { dispatch(get_Data_VODID_Drp_Data(loginAgencyID)) };
            if (stateList?.length === 0) { dispatch(get_State_Drp_Data()) };
        }
    }, [loginAgencyID, selectedIncidentID, effectiveIncidentID])

    const check_Validation_Error = (e) => {
        const shouldSkipVehicleDetailValidation = isLossCodeNoneOrUnknown;
        const LossCodeIDErr = RequiredFieldIncident(value.LossCodeID);
        const CategoryIDErr = shouldSkipVehicleDetailValidation ? 'true' : RequiredFieldIncident(value.CategoryID);
        const PlateTypeIDErr = shouldSkipVehicleDetailValidation ? 'true' : RequiredFieldIncident(value.PlateTypeID);
        const PlateStateNoErr = shouldSkipVehicleDetailValidation ? 'true' : (categoryCode === "NMVs" || plateTypeCode === "Unknown" ? 'true' : RequiredFieldIncident(value.PlateID));
        const VehicleNoErr = shouldSkipVehicleDetailValidation ? 'true' : (value.PlateID == '' || value.PlateID === null ? 'true' : RequiredFieldIncident(value.VehicleNo))
        const ContactErr = lossCode === 'STOL' || lossCode === 'BURN' || lossCode === 'RECD' ? RequiredFieldOnConditon(value.Value) : 'true';
        const UnderJurisdictionErr = isLossCodeNoneOrUnknown
            ? 'true'
            : (isRecoveredLossCode(value?.LossCodeID) && value?.UnderJurisdiction === true)
                ? ''
                : 'true';

        const vinErr = shouldSkipVehicleDetailValidation ? 'true' : (value?.VIN.length > 0 && value?.VIN.length < 17 ? "Enter Minimum 17 Characters" : 'true');
        setErrors(pre => {
            return {
                ...pre,
                ['LossCodeIDError']: LossCodeIDErr || pre['LossCodeIDError'],
                ['CategoryIDError']: CategoryIDErr || pre['CategoryIDError'],
                ['PlateTypeIDError']: PlateTypeIDErr || pre['PlateTypeIDError'],
                ['PlateStateNoError']: PlateStateNoErr || pre['PlateStateNoError'],
                ['ContactError']: ContactErr || pre['ContactError'],
                ['VehicleNoError']: VehicleNoErr || pre['VehicleNoError'],
                ['vinLengthError']: vinErr || pre['vinLengthError'],
                ['UnderJurisdictionError']: UnderJurisdictionErr || pre['UnderJurisdictionError'],

            }
        });
    }

    const { LossCodeIDError, CategoryIDError, RecoveryTypeIDError, PlateTypeIDError, PlateStateNoError, ContactError, VehicleNoError, vinLengthError, UnderJurisdictionError } = errors

    useEffect(() => {
        if (LossCodeIDError === 'true' && CategoryIDError === 'true' && PlateTypeIDError === 'true' && PlateStateNoError === 'true' && ContactError === 'true' && VehicleNoError === 'true' && vinLengthError === 'true') {
            if (MstVehicle === 'MST-Vehicle-Dash') {
                if (masterPropertyID) { Update_Vehicle(); }
                else { Insert_Vehicle(); }
            } else {
                if (vehicleID && (VehSta === "true" || VehSta === true)) {
                    Update_Vehicle();
                    return;
                } else { Insert_Vehicle(); return; }
            }
        }
    }, [LossCodeIDError, CategoryIDError, RecoveryTypeIDError, PlateTypeIDError, PlateStateNoError, ContactError, VehicleNoError, vinLengthError, UnderJurisdictionError])

    const GetSingleData = (vehicleID, masterPropertyID) => {
        const val = { 'PropertyID': 0, 'MasterPropertyID': masterPropertyID, 'IsMaster': true, 'PINID': loginPinID }
        const val1 = { 'PropertyID': vehicleID, 'MasterPropertyID': 0, 'IsMaster': false, 'PINID': loginPinID }

        fetchPostData('PropertyVehicle/GetSingleData_PropertyVehicle', MstVehicle === "MST-Vehicle-Dash" ? val : val1).then((res) => {
            if (res.length > 0) {
                setVehicleStatus(true)
                setEditval(res);
            } else { setEditval([]) }
        })
    }

    useEffect(() => {
        if (editval) {
            dispatch(get_Masters_Name_Drp_Data(editval[0]?.OwnerID));
            dispatch(get_Masters_PossessionOwnerData(editval[0]?.InProfessionOf));
            setcountoffaduit(true);
            dispatch(get_Classification_Drp_Data(editval[0]?.CategoryID));
            get_StyleId_Drp_Data(loginAgencyID, editval[0]?.CategoryID);
            get_MakeId_Drp_Data(loginAgencyID, editval[0]?.CategoryID);
            setLossCode(Get_LossCode(editval, propertyLossCodeData));
            setCategoryCode(getCategoryCode(editval, categoryIdDrp));
            dispatch(get_ModalId_Drp_Data(loginAgencyID, editval[0]?.MakeID));
            dispatch({ type: MasterVehicle_ID, payload: editval[0]?.MasterPropertyID });
            dispatch({ type: Vehicle_ID, payload: MstVehicle === 'MST-Vehicle-Dash' ? '' : editval[0]?.VehicleID });
            sessionStorage.setItem("vehicleStolenValue", Encrypted_Id_Name(editval[0]?.Value, 'VForVehicleStolenValue'));
            setVehicleIDNCICModal(editval[0]?.VehicleID);
            setValue({
                ...value,
                'LossCodeID': editval[0]?.LossCodeID,
                'NICBID': editval[0]?.NICBID, 'TagID': editval[0]?.TagID, 'PrimaryOfficerID': editval[0]?.PrimaryOfficerID, 'SecondaryColorID': editval[0]?.SecondaryColorID, 'PrimaryColorID': editval[0]?.PrimaryColorID,
                'OwnerID': editval[0]?.OwnerID, 'ModelID': editval[0]?.ModelID, 'MakeID': editval[0]?.MakeID, 'StyleID': editval[0]?.StyleID, 'OANID': editval[0]?.OANID, 'VODID': editval[0]?.VODID,
                'ClassificationID': editval[0]?.ClassificationID, 'PlateTypeID': editval[0]?.PlateTypeID, 'PlateID': editval[0]?.PlateID ? editval[0]?.PlateID : '', 'CategoryID': editval[0]?.CategoryID,
                'VehicleNumber': editval[0]?.VehicleNumber, 'ReportedDtTm': editval[0]?.ReportedDtTm ? getShowingDateText(editval[0]?.ReportedDtTm) : '', 'IsEligibleForImmobalization': !!editval[0]?.IsEligibleForImmobalization,
                'IsImmobalizationDevice': !!editval[0]?.IsImmobalizationDevice, 'IsPropertyRecovered': !!editval[0]?.IsPropertyRecovered, 'ModelName': editval[0]?.ModelName, 'IsEvidence': !!editval[0]?.IsEvidence, 'IsVehicleImpound': !!editval[0]?.IsVehicleImpound, 'IsRecoveredByAgencyOfOther': !!editval[0]?.IsRecoveredByAgencyOfOther,
                'InProfessionOf': editval[0]?.InProfessionOf, 'Description': editval[0]?.Description, 'DestroyDtTm': editval[0]?.DestroyDtTm, 'InspectionExpiresDtTm': editval[0]?.InspectionExpiresDtTm,
                'Inspection_Sticker': editval[0]?.Inspection_Sticker, 'Weight': editval[0]?.Weight, 'ManufactureYear': editval[0]?.ManufactureYear, 'VIN': editval[0]?.VIN ? editval[0]?.VIN : '',
                'VehicleNo': editval[0]?.VehicleNo, 'PlateExpireDtTm': editval[0]?.PlateExpireDtTm, 'ModifiedByUserFK': loginPinID, 'PropertyID': editval[0]?.PropertyID, 'MasterPropertyID': editval[0]?.MasterPropertyID,
                'IsSendToPropertyRoom': !!editval[0]?.IsSendToPropertyRoom, 'Value': editval[0]?.Value ? editval[0]?.Value : "",
                'UnderJurisdiction': !!editval[0]?.RecoveredPropertyUnderJurisdiction,

                'PlateExpirationMonth': editval[0]?.PlateExpirationMonth, 'PlateExpirationYear': editval[0]?.PlateExpirationYear,
            });

            setPossessionID(editval[0]?.InProfessionOf); setOwnerOfID(parseInt(editval[0]?.OwnerID));
            setnibrsSubmittedvehicleMain(editval[0]?.IsNIBRSSummited);
            get_Vehicle_MultiImage(editval[0]?.PropertyID, editval[0]?.MasterPropertyID); setVehicleID(editval[0]?.PropertyID);
            setMasterPropertyID(editval[0]?.MasterPropertyID); setDestoryDate(editval[0]?.DestroyDtTm ? new Date(editval[0]?.DestroyDtTm) : '');
            setInspectionExpDate(editval[0]?.InspectionExpiresDtTm ? new Date(editval[0]?.InspectionExpiresDtTm) : '');
            setManufactureDate(editval[0]?.ManufactureYear ? new Date(editval[0]?.ManufactureYear) : ''); setPlateExpDate(editval[0]?.PlateExpireDtTm ? new Date(editval[0]?.PlateExpireDtTm) : '');
            setIncidentReportedDate(editval[0]?.ReportedDtTm ? new Date(editval[0]?.ReportedDtTm) : null);
            // if (editval[0]?.LossCodeID === 3 || editval[0]?.LossCodeID === 12 || editval[0]?.LossCodeID === 10) {
            //     setShowVehicleRecovered(true)
            // }
            if (editval[0]?.IsEvidence) {
                SetNavigateStatus(true);
            }
            if (editval[0]?.IsSendToPropertyRoom) {
                setPropertyStatus(true);
            }

        } else {
            setValue({
                ...value,
                'ReportedDtTm': MstVehicle === "MST-Vehicle-Dash" ? getShowingMonthDateYear(new Date(datezone)) : incReportedDate ? getShowingDateText(incReportedDate) : getShowingMonthDateYear(new Date()),
                'VehicleNumber': '', 'VehicleNo': '', 'PlateID': null, 'OANID': '', 'Inspection_Sticker': '', 'InspectionExpiresDtTm': '', 'AgencyID': loginAgencyID,
                'LossCodeID': null, 'CategoryID': null, 'PlateTypeID': null, 'ClassificationID': null,
                'VIN': '', 'VODID': '', 'PlateExpireDtTm': '', 'StyleID': '', 'MakeID': null, 'ModelID': null, 'ManufactureYear': '',
                'Weight': '', 'OwnerID': null, 'PrimaryColorID': '', 'SecondaryColorID': '', 'Value': '',
                'PrimaryOfficerID': null, 'InProfessionOf': '', 'TagID': null, 'NICBID': null, 'DestroyDtTm': '', 'Description': '',
                'IsEvidence': '', 'IsRecoveredByAgencyOfOther': '', 'IsPropertyRecovered': '', 'IsImmobalizationDevice': '', 'IsEligibleForImmobalization': '', 'ModelName': '', 'IsVehicleImpound': '',
                'UnderJurisdiction': false,
                'PlateExpirationMonth': '', 'PlateExpirationYear': '',
            });
            setuploadImgFiles([]); setVehicleMultiImg([]);
            SetNavigateStatus(false);
            setVehicleIDNCICModal("");
        }
    }, [editval]);

    useEffect(() => {
        propertyLossCodeData?.filter(val => {
            if (val.value === value?.LossCodeID) {
                if (val.id === "RECD" || val.id === "STOL") {
                    setShowVehicleRecovered(true);
                } else {
                    setShowVehicleRecovered(false);
                }
            }
        });
    }, [value.LossCodeID, propertyLossCodeData]);

    const get_RecoveredVehicle_Data = (propertyID, masterPropID) => {
        const val = { 'PropertyID': 0, 'MasterPropertyID': masterPropID, 'IsMaster': true }
        const val1 = { 'PropertyID': propertyID, 'MasterPropertyID': 0, 'IsMaster': false }
        fetchPostData('VehicleRecovered/GetData_VehicleRecovered', MstVehicle === "MST-Vehicle-Dash" ? val : val1).then((res) => {
            if (res) {
                setRecoveredVehicleData(res);
            } else {
                setRecoveredVehicleData([]);
            }
        }).catch(() => {
            setRecoveredVehicleData([]);
        })
    }

    useEffect(() => {
        if (MstVehicle === "MST-Vehicle-Dash") {
            if (masterPropertyID) {
                get_RecoveredVehicle_Data(0, masterPropertyID);
            } else {
                setRecoveredVehicleData([]);
            }
        } else {
            if (vehicleID) {
                get_RecoveredVehicle_Data(vehicleID, 0);
            } else {
                setRecoveredVehicleData([]);
            }
        }
    }, [vehicleID, masterPropertyID, MstVehicle]);

    const PropertyType = (loginAgencyID) => {
        const val = { AgencyID: loginAgencyID }
        fetchPostData('PropertyCategory/GetDataDropDown_PropertyCategory', val).then((data) => {
            if (data) {
                const res = data?.filter((val) => {
                    if (val.PropertyCategoryCode === "V") return val
                })
                if (res.length > 0) {
                    get_CategoryId_Drp(res[0]?.PropertyCategoryID)
                }
            }
        })
    }

    const get_CategoryId_Drp = (CategoryID) => {
        const val = { CategoryID: CategoryID }
        fetchPostData('Property/GetDataDropDown_PropertyType', val).then((data) => {
            if (data) {
                setCategoryIdDrp(threeColArray(data, 'PropertyDescID', 'Description', 'PropDescCode'))
            } else {
                setCategoryIdDrp([]);
            }
        })
    }

    const get_MakeId_Drp_Data = (LoginAgencyID, CategoryID) => {
        const val = { AgencyID: LoginAgencyID, PropertyDescID: CategoryID }
        fetchPostData('PropertyVehicleMake/GetDataDropDown_PropertyVehicleMake', val).then((data) => {
            if (data) {
                setVehMakeDrpData(Comman_changeArrayFormat(data, 'PropertyVehicleMakeID', 'Description'))
            } else {
                setVehMakeDrpData([]);
            }
        })
    }

    const get_StyleId_Drp_Data = (LoginAgencyID, CategoryID) => {
        const val = { AgencyID: LoginAgencyID, PropertyDescID: CategoryID }
        fetchPostData('PropertyVehicleStyle/GetDataDropDown_PropertyVehicleStyle', val).then((data) => {
            if (data) {
                setStyleDrpData(Comman_changeArrayFormat(data, 'VehicleStyleID', 'Description'))
            } else {
                setStyleDrpData([]);
            }
        })
    }

    const ChangeDropDown = (e, name) => {
        !addUpdatePermission && setStatesChangeStatus(true);
        !addUpdatePermission && setChangesStatus(true);
        if (e) {
            if (name === 'MakeID') {
                dispatch(get_ModalId_Drp_Data(loginAgencyID, e.value));
                setValue(prev => ({ ...prev, MakeID: e.value, ModelID: 0 }));
            }
            else if (name === 'ModelID') {
                if (e?.__isNew__) {
                    setValue({ ...value, ModelID: '', ModelName: e.label, });
                } else if (e) {
                    setValue({ ...value, ModelID: e.value, ModelName: '', });
                } else {
                    setValue({ ...value, ModelID: '', ModelName: '', });
                }
            }
            else if (name === 'CategoryID') {
                setCategoryCode(e.id);
                setPlateTypeCode("");
                dispatch(get_Classification_Drp_Data(e.value));
                get_StyleId_Drp_Data(loginAgencyID, e.value);
                get_MakeId_Drp_Data(loginAgencyID, e.value);
                setValue(prev => ({
                    ...prev, [name]: e.value, MakeID: '', StyleID: ''
                }));
            } else if (name === 'PlateTypeID') {
                setPlateTypeCode(e.id);
                setValue(prev => ({ ...prev, [name]: e.value }));
            } else {
                setValue(prev => ({ ...prev, [name]: e.value }));
            }
        } else if (e === null) {
            if (name === 'CategoryID') {
                setCategoryCode('');
                setPlateTypeCode('');
                setValue(prev => ({
                    ...prev, CategoryID: '', ClassificationID: '', MakeID: '', StyleID: ''
                }));
                dispatch(get_Classification_Drp_Data(''));
                dispatch({ type: Classification_Drp_Data, payload: [] });
                setVehMakeDrpData([]);
                setStyleDrpData([]);
            } else if (name === 'MakeID') {
                setValue(prev => ({ ...prev, MakeID: '', ModelID: '', ModelName: '' }));
                dispatch(get_ModalId_Drp_Data(loginAgencyID, ''));
            }
            else if (name === 'ModelID') {
                setValue(prev => ({ ...prev, ModelID: '', ModelName: '', }));
            }
            else if (name === 'PlateTypeID') {
                setPlateTypeCode("");
                setValue(prev => ({ ...prev, [name]: null }));
            } else {
                setValue(prev => ({ ...prev, [name]: null }));
            }
        } else {
            setValue(prev => ({ ...prev, [name]: null }));
        }
    };

    const onInProfessionChange = (e, name) => {
        !addUpdatePermission && setStatesChangeStatus(true); !addUpdatePermission && setChangesStatus(true);
        if (e) {
            if (name === 'InProfessionOf') {
                setPossessionID(e.value); GetSingleDataPassion(e.value, 0); setPossenSinglData([]); setValue({ ...value, [name]: e.value });
            } else if (name === 'OwnerID') {
                setOwnerOfID(e.value); GetSingleDataPassion(e.value, 0); setPossenSinglData([]); setValue({ ...value, [name]: e.value });
            }
        } else {
            if (name === 'InProfessionOf') {
                setPossessionID(''); setPossenSinglData([]); setValue({ ...value, [name]: null });
            } else if (name === 'OwnerID') {
                setOwnerOfID(''); setPossenSinglData([]); setValue({ ...value, [name]: null });
            }
        }
    }

    const HandleChanges = (e) => {
        !addUpdatePermission && setStatesChangeStatus(true); !addUpdatePermission && setChangesStatus(true);
        if (e.target.name === 'IsEvidence' || e.target.name === 'IsVehicleImpound' || e.target.name === 'IsRecoveredByAgencyOfOther' || e.target.name === 'IsPropertyRecovered' || e.target.name === 'IsSendToPropertyRoom' || e.target.name === 'IsImmobalizationDevice' || e.target.name === 'IsEligibleForImmobalization' || e.target.name === 'UnderJurisdiction') {
            setValue((prev) => ({
                ...prev,
                [e.target.name]: e.target.checked,
            }));
            if (e.target.name === 'UnderJurisdiction') {
                setErrors((prev) => ({ ...prev, ['UnderJurisdictionError']: 'true' }));
            }

        } else if (e.target.name === 'Value') {
            const ele = e.target.value.replace(/[^0-9\.]/g, "")
            if (ele.includes('.')) {
                if (ele.length === 16) {
                    setValue({ ...value, [e.target.name]: ele });
                } else {
                    if (ele.substr(ele.indexOf('.') + 1).slice(0, 2)) {
                        const checkDot = ele.substr(ele.indexOf('.') + 1).slice(0, 2).match(/\./g)
                        if (!checkDot) {
                            setValue({ ...value, [e.target.name]: ele.substring(0, ele.indexOf(".")) + '.' + ele.substr(ele.indexOf('.') + 1).slice(0, 2) });
                            return;
                        } else {
                            return;
                        }
                    } else { setValue({ ...value, [e.target.name]: ele }) }
                }
            } else {
                setValue({ ...value, [e.target.name]: ele });
            }

        } else if (e.target.name === 'Weight') {
            const checkNumber = e.target.value.replace(/[^0-9\s]/g, "");

            setValue({ ...value, [e.target.name]: checkNumber })
        } else if (e.target.name === 'OANID') {
            var ele = e.target.value.replace(/[^0-9a-zA-Z]/g, "")
            const checkNumber = ele.toUpperCase();

            setValue({ ...value, [e.target.name]: checkNumber })

        }
        else if (e.target.name === 'VIN') {
            var ele = e.target.value.replace(/[^0-9a-zA-Z]+$/g, "")
            var eleIOQ = ele.replace(/[IOQ]/gi, '');
            const checkNumber = eleIOQ.toUpperCase();

            setValue({ ...value, [e.target.name]: checkNumber })
        }

        else {
            setValue({
                ...value,
                [e.target.name]: e.target.value
            });
        }
    }

    const Insert_Vehicle = () => {
        const payload = {
            ...value,
            RecoveredPropertyUnderJurisdiction: !!value?.UnderJurisdiction,
        };
        AddDeleteUpadate('PropertyVehicle/Insert_PropertyVehicle', payload).then((res) => {
            if (res.success) {
                refetchNibrsLeftTreeErrors();
                if (isCad) {
                    if (MstVehicle === 'MST-Vehicle-Dash') {
                        navigate(`/cad/dispatcher?page=MST-Vehicle-Dash&VehId=${stringToBase64(res?.PropertyID)}&MVehId=${stringToBase64(res?.MasterPropertyID)}&ModNo=${res?.VehicleNumber}&VehSta=${true}`)
                    } else {
                        navigate(`/cad/dispatcher?IncId=${stringToBase64(IncID)}&IncNo=${IncNo}&IncSta=${IncSta}&VehId=${stringToBase64(res?.PropertyID)}&MVehId=${stringToBase64(res?.MasterPropertyID)}&VehSta=${true}`)
                    }
                }
                else if (isCaseManagement) {
                    if (onAfterInsert) {
                        onAfterInsert(res);
                    } else if (isPropertyEvidence) {
                        navigate(`/inc-case-management?IncId=${stringToBase64(IncID)}&IncNo=${IncNo}&IncSta=${IncSta}&VehId=${stringToBase64(res?.PropertyID)}&MVehId=${stringToBase64(res?.MasterPropertyID)}&VehSta=${true}${CaseId ? `&CaseId=${CaseId}` : ''}&CaseManagementPage=propertyEvidence`)
                    } else {
                        navigate(`/inc-case-management?IncId=${stringToBase64(IncID)}&IncNo=${IncNo}&IncSta=${IncSta}&VehId=${stringToBase64(res?.PropertyID)}&MVehId=${stringToBase64(res?.MasterPropertyID)}&VehSta=${true}&CaseManagementPage=home`)
                    }
                }
                else {
                    if (MstVehicle === 'MST-Vehicle-Dash') {
                        navigate(`/Vehicle-Home?page=MST-Vehicle-Dash&VehId=${stringToBase64(res?.PropertyID)}&MVehId=${stringToBase64(res?.MasterPropertyID)}&ModNo=${res?.VehicleNumber}&VehSta=${true}`)
                    } else {
                        navigate(`/Vehicle-Home?IncId=${stringToBase64(IncID)}&IncNo=${IncNo}&IncSta=${IncSta}&VehId=${stringToBase64(res?.PropertyID)}&MVehId=${stringToBase64(res?.MasterPropertyID)}&VehSta=${true}`)
                    }
                }
                reset();
                if (uploadImgFiles?.length > 0) {
                    upload_Image_File(res.PropertyID, res.MasterPropertyID);
                    setuploadImgFiles([])
                }
                if (isCaseManagement) {
                    refetchPropertyForCaseManagementData();
                }
                toastifySuccess(res.Message);
                setErrors({ ...errors, ['LossCodeIDError']: '' }); get_Incident_Count(mainIncidentID, loginPinID); get_Data_Vehicle(mainIncidentID);
                setUpdateCount(updateCount + 1); PropertyType(loginAgencyID);
                setChangesStatus(false); setStatesChangeStatus(false); setStatus(false); setMasterPropertyID(res?.MasterPropertyID);
                // validateIncSideBar
                validate_IncSideBar(mainIncidentID, IncNo, loginAgencyID);
                // nibrsValidateProperty(mainIncidentID)
            } else {
                toastifyError('Error'); setErrors({ ...errors, ['LossCodeIDError']: '' });
            }
        })
    }

    const Update_Vehicle = () => {

        const previousValue = value.Value;
        const payload = {
            ...value,
            RecoveredPropertyUnderJurisdiction: !!value?.UnderJurisdiction,
        };
        AddDeleteUpadate('PropertyVehicle/Update_PropertyVehicle', payload).then((res) => {
            if (res.success) {
                const parsedData = JSON.parse(res.data);
                const message = parsedData.Table[0].Message;
                toastifySuccess(message);
                refetchNibrsLeftTreeErrors();
                GetSingleData(vehicleID, masterPropertyID); setChangesStatus(false); setStatesChangeStatus(false);
                setUpdateCount(updateCount + 1); get_Data_Vehicle(mainIncidentID);
                setErrors({ ...errors, ['LossCodeIDError']: '' });
                setValue({ ...value, Value: previousValue, }); get_List(vehicleID);
                if (isCaseManagement) {
                    refetchPropertyForCaseManagementData();
                }
                if (uploadImgFiles?.length > 0) { upload_Image_File(); setuploadImgFiles([]); }
                // validateIncSideBar
                validate_IncSideBar(mainIncidentID, IncNo, loginAgencyID);
                // nibrsValidateProperty(mainIncidentID)
            } else {
                toastifyError('Error');
                setErrors({ ...errors, ['LossCodeIDError']: '' });
            }
        })
    }

    const reset = () => {
        setValue({
            ...value,
            'VehicleNumber': '', 'LossCodeID': '', 'CategoryID': '', 'PlateID': '', 'VehicleNo': '', 'PlateTypeID': '', 'ClassificationID': '',
            'VIN': '', 'VODID': '', 'PlateExpireDtTm': '', 'OANID': '', 'StyleID': '', 'MakeID': '', 'ModelID': '', 'ManufactureYear': '',
            'Weight': '', 'OwnerID': '', 'PrimaryColorID': '', 'SecondaryColorID': '', 'Value': '', 'Inspection_Sticker': '', 'InspectionExpiresDtTm': '', 'ModelName': '',
            'InProfessionOf': '', 'TagID': '', 'NICBID': '', 'DestroyDtTm': '', 'Description': '', 'PrimaryOfficerID': '',
            'IsEvidence': '', 'IsRecoveredByAgencyOfOther': '', 'IsPropertyRecovered': '', 'IsImmobalizationDevice': '', 'IsEligibleForImmobalization': '', 'IsSendToPropertyRoom': '', 'IsVehicleImpound': '',
            'UnderJurisdiction': false,
            'ReportedDtTm': MstVehicle === "MST-Vehicle-Dash" ? getShowingMonthDateYear(new Date(datezone)) : incReportedDate ? getShowingDateText(incReportedDate) : getShowingMonthDateYear(new Date()),
            "MasterPropertyID": '', 'PropertyID': '', 'IsMasterManufactureYear': '', 'IsMasterIsEvidence': '',
            'PlateExpirationMonth': '', 'PlateExpirationYear': '',

        });
        SetNavigateStatus(false);
        setVehicleIDNCICModal("");
        setShowVehicleRecovered(false);
        setErrors({
            ...errors,
            'LossCodeIDError': '', 'CategoryIDError': '', 'RecoveryTypeIDError': '', 'PlateTypeIDError': '', 'PlateStateNoError': '', 'VehicleNoError': '', 'ContactError': '', 'vinLengthError': '', 'UnderJurisdictionError': '', 'RecoveredVehicleDataError': ''
        });
        setnibrsSubmittedvehicleMain(0); setPlateExpDate(); setManufactureDate(); setInspectionExpDate(); setDestoryDate();
        setOwnerOfID('');
        setChangesStatus(false)
        setMasterPropertyID('');
        dispatch({ type: MasterVehicle_ID, payload: '' });
        dispatch({ type: Classification_Drp_Data, payload: [] });
        dispatch({ type: Vehicle_ID, payload: '' });
        setVehicleID(''); setLossCode(''); setAvailableAlert([]);
        setPropertyStatus(false); setPossessionID(''); dispatch(get_Masters_Name_Drp_Data(''));
        dispatch(get_Masters_PossessionOwnerData('')); setPlateTypeCode(''); setCategoryCode(''); setVehMakeDrpData([]);
        setStyleDrpData([]);
        setVehicleStatus(false);
        setuploadImgFiles([]); setVehicleMultiImg([]);
        setResetErrors(false);

    }

    const WidhoutColorStyles = {
        control: (styles) => ({
            ...styles,
            height: 20,
            minHeight: 33,
            fontSize: 14,
            margintop: 2,
            boxShadow: 0,
        }),
    };


    const startRef = React.useRef();
    const startRef1 = React.useRef();
    const startRef2 = React.useRef();
    const startRef3 = React.useRef();
    const startRef4 = React.useRef();

    const onKeyDown = (e) => {
        if (e.target.id === 'ReportedDate') {
            e.preventDefault();
        } else if (e.keyCode === 9 || e.which === 9) {
            startRef.current.setOpen(false);
            startRef1.current.setOpen(false);
            startRef2.current.setOpen(false);
            startRef3.current.setOpen(false);
            startRef4.current.setOpen(false);

        }
    };

    const get_Vehicle_MultiImage = (vehicleID, masterPropertyID) => {
        const val = { 'PropertyID': vehicleID, 'IsMaster': false, }
        const val1 = { 'PropertyID': 0, 'MasterPropertyID': masterPropertyID, 'IsMaster': true }
        fetchPostData('PropertyVehicle/GetData_PropertyVehiclePhoto', MstVehicle === "MST-Vehicle-Dash" ? val1 : val)
            .then((res) => {
                if (res?.length > 0) {
                    setVehicleMultiImg(res);
                    SetImageModalOfficerID(res[0]?.OfficerID);

                } else {
                    setVehicleMultiImg([]);
                    // for clearing uploded img if it has on cancle button
                    setuploadImgFiles([]);
                    SetImageModalOfficerID(null);

                }
            })
    }

    const update_Vehicle_MultiImage = () => {
        const val = { "ModifiedByUserFK": loginPinID, "AgencyID": loginAgencyID, "PictureTypeID": imgData?.PictureTypeID, "ImageViewID": imgData?.ImageViewID, "ImgDtTm": imgData?.ImgDtTm, "OfficerID": imgData?.OfficerID, "Comments": imgData?.Comments, "DocumentID": imgData?.DocumentID }
        AddDeleteUpadate('PropertyVehicle/Update_PropertyVehiclePhotoDetail', val)
            .then((res) => {
                if (res.success) {
                    const parsedData = JSON.parse(res.data);
                    const message = parsedData.Table[0].Message;
                    toastifySuccess(message);

                }
                else {
                    toastifyError(res?.Message);
                }
            })

    }

    const upload_Image_File = async (vehID, vehMID) => {
        const formdata = new FormData();
        const newData = [];
        const EncFormdata = new FormData();
        const EncDocs = [];
        for (let i = 0; i < uploadImgFiles.length; i++) {
            const { file, imgData } = uploadImgFiles[i];

            const val = {
                'PropertyID': vehicleID ? vehicleID : vehID, 'MasterPropertyID': masterPropertyID ? masterPropertyID : vehMID,
                'CreatedByUserFK': loginPinID, 'AgencyID': loginAgencyID, 'PictureTypeID': imgData?.PictureTypeID,
                'ImageViewID': imgData?.ImageViewID, 'ImgDtTm': imgData?.ImgDtTm, 'OfficerID': imgData?.OfficerID,
                'Comments': imgData?.Comments, 'IsMaster': MstVehicle === "MST-Property-Dash" ? true : false, 'AgencyID': loginAgencyID,
            };

            const val1 = {
                'PropertyID': 0, 'MasterPropertyID': masterPropertyID ? masterPropertyID : vehMID,
                'CreatedByUserFK': loginPinID, 'AgencyID': loginAgencyID, 'PictureTypeID': imgData?.PictureTypeID,
                'ImageViewID': imgData?.ImageViewID, 'ImgDtTm': imgData?.ImgDtTm, 'OfficerID': imgData?.OfficerID,
                'Comments': imgData?.Comments, 'IsMaster': MstVehicle === "MST-Vehicle-Dash" ? true : false, 'AgencyID': loginAgencyID,
            };

            const values = JSON.stringify(MstVehicle === 'MST-Vehicle-Dash' ? val1 : val);
            newData.push(values);

            const EncPostData = await Aes256Encrypt(JSON.stringify([JSON.stringify(MstVehicle === 'MST-Vehicle-Dash' ? val1 : val)]));
            EncDocs.push(EncPostData);
            formdata.append("file", file);
            EncFormdata.append("file", file);
        }
        formdata.append("Data", JSON.stringify(newData));
        EncFormdata.append("Data", EncDocs);
        AddDelete_Img('PropertyVehicle/Insert_PropertyVehiclePhoto', formdata, EncFormdata)
            .then((res) => {
                if (res.success) {
                    get_Vehicle_MultiImage(vehicleID ? vehicleID : vehID, masterPropertyID ? masterPropertyID : vehMID);
                    setuploadImgFiles([]);
                }
            })
            .catch(err => console.error(err));
    };

    const delete_Image_File = (e) => {
        const value = { 'PhotoID': imageId, 'DeletedByUserFK': loginPinID }
        AddDeleteUpadate('PropertyVehicle/Delete_PropertyVehiclePhoto', value).then((data) => {
            if (data.success) {
                const parsedData = JSON.parse(data.data);
                const message = parsedData.Table[0].Message;
                toastifySuccess(message);
                get_Vehicle_MultiImage(vehicleID, masterPropertyID);
                setModalStatus(false);
                setImageId('');
            } else {
                toastifyError(data?.Message);
            }
        });
    }
    const ChangePhoneType = (e, name) => {
        !addUpdatePermission && setStatesChangeStatus(true); !addUpdatePermission && setChangesStatus(true);
        if (e) {
            if (name === 'LossCodeID') {
                const currentLossCodeIsRecoveredOrStolen = isRecoveredOrStolenLossCode(value?.LossCodeID);
                const hasRecoveredVehicleData = recoveredVehicleData && recoveredVehicleData.length > 0;
                if (currentLossCodeIsRecoveredOrStolen && hasRecoveredVehicleData) {
                    setErrors((prev) => ({ ...prev, ['RecoveredVehicleDataError']: 'Loss Code cannot be changed because recovered vehicle data exists' }));
                    return;
                }
                setErrors((prev) => ({ ...prev, ['RecoveredVehicleDataError']: 'true' }));

                setLossCode(e.id);
                const selectedLossCode = String(e?.id ?? '').trim().toUpperCase();
                const selectedLossLabel = String(e?.label ?? '').trim().toUpperCase();
                const shouldClearFields = selectedLossCode.includes('NONE') || selectedLossCode.includes('UNKNOWN')
                    || selectedLossLabel.includes('NONE') || selectedLossLabel.includes('UNKNOWN');
                const isStolenVehicle = selectedLossCode === 'STOL';
                const isRecoveredOrStolen = selectedLossCode === 'RECD' || selectedLossCode === 'STOL';
                const newUnderJurisdiction = isStolenVehicle ? true : (isRecoveredOrStolen ? value?.UnderJurisdiction : false);

                if (shouldClearFields) {
                    setShowVehicleRecovered(false);
                    setCategoryCode('');
                    setPlateTypeCode('');
                    setValue((prev) => ({
                        ...prev,
                        'VehicleNumber': '',
                        'CategoryID': '',
                        'PlateID': '',
                        'VehicleNo': '',
                        'PlateTypeID': '',
                        'ClassificationID': '',
                        'VIN': '',
                        'VODID': '',
                        'PlateExpireDtTm': '',
                        'OANID': '',
                        'StyleID': '',
                        'MakeID': '',
                        'ModelID': '',
                        'ManufactureYear': '',
                        'Weight': '',
                        'OwnerID': '',
                        'PrimaryColorID': '',
                        'SecondaryColorID': '',
                        'Value': '',
                        'Inspection_Sticker': '',
                        'InspectionExpiresDtTm': '',
                        'ModelName': '',
                        'InProfessionOf': '',
                        'TagID': '',
                        'NICBID': '',
                        'DestroyDtTm': '',
                        'Description': '',
                        'PrimaryOfficerID': '',
                        'IsEvidence': '',
                        'IsRecoveredByAgencyOfOther': '',
                        'IsPropertyRecovered': '',
                        'IsImmobalizationDevice': '',
                        'IsEligibleForImmobalization': '',
                        'IsSendToPropertyRoom': '',
                        'IsVehicleImpound': '',
                        'MasterPropertyID': '',
                        'PropertyID': '',
                        'IsMasterManufactureYear': '',
                        'IsMasterIsEvidence': '',
                        'PlateExpirationMonth': '',
                        'PlateExpirationYear': '',
                        'UnderJurisdiction': false,
                        'ReportedDtTm': prev?.ReportedDtTm,
                        [name]: e.value,
                    }));
                } else {
                    setValue((prev) => ({ ...prev, [name]: e.value, 'UnderJurisdiction': newUnderJurisdiction }));
                }
                setErrors((prev) => ({ ...prev, ['UnderJurisdictionError']: 'true' }));
            } else {

                setValue({ ...value, [name]: e.value, });
            }
        } else if (e === null) {
            if (name === 'LossCodeID') {
                const currentLossCodeIsRecoveredOrStolen = isRecoveredOrStolenLossCode(value?.LossCodeID);
                const hasRecoveredVehicleData = recoveredVehicleData && recoveredVehicleData.length > 0;
                if (currentLossCodeIsRecoveredOrStolen && hasRecoveredVehicleData) {
                    setErrors((prev) => ({ ...prev, ['RecoveredVehicleDataError']: 'Loss Code cannot be changed because recovered vehicle data exists' }));
                    return;
                }
                setErrors((prev) => ({ ...prev, ['RecoveredVehicleDataError']: 'true' }));

                setLossCode('');
                setValue((prev) => ({ ...prev, [name]: null, 'UnderJurisdiction': false }));
                setErrors((prev) => ({ ...prev, ['UnderJurisdictionError']: 'true' }));
            }
        }
    };

    const newVehicle = () => {
        SetNewClciked((prev) => prev + 1);
        SetImageModalOfficerID(null);
        SetNavigateStatus(false);
        if (MstVehicle === 'MST-Vehicle-Dash') {
            if (isCad) {
                if (isCADSearch) {
                    navigate(`/cad/vehicle_search?page=MST-Vehicle-Dash&?VehId=${0}&?MVehId=${0}&ModNo=${''}`);
                } else {
                    navigate(`/cad/dispatcher?page=MST-Vehicle-Dash&?VehId=${0}&?MVehId=${0}&ModNo=${''}&isNew=${true}`)
                }
            } else if (isCaseManagement) {
                if (isPropertyEvidence) {
                    navigate(`/inc-case-management?IncId=${stringToBase64(IncID)}&IncNo=${IncNo}&IncSta=${IncSta}&VehId=${0}&MVehId=${0}&VehSta=${false}&isNew=${true}&CaseManagementPage=propertyEvidence`)
                } else {
                    navigate(`/inc-case-management?IncId=${stringToBase64(IncID)}&IncNo=${IncNo}&IncSta=${IncSta}&VehId=${0}&MVehId=${0}&VehSta=${false}&isNew=${true}&CaseManagementPage=home`)
                }
            }
            else {
                navigate(`/Vehicle-Home?page=MST-Vehicle-Dash&?VehId=${0}&?MVehId=${0}&ModNo=${''}&VehSta=${false}&isNew=${true}`)
            }
            reset(); setPossessionID(''); setOwnerOfID(''); setPossenSinglData([]);
            setClickedRow(null); setVehicleStatus(false);
            setStatus(false); get_vehicle_Count(''); PropertyType(loginAgencyID);
            setVehicleMultiImg([]);
            setuploadImgFiles([]);

            // dispatch({ type: Master_Vehicle_Status, payload: false });

        } else {
            if (isCad) {
                navigate(`/cad/dispatcher?IncId=${stringToBase64(IncID)}&IncNo=${IncNo}&IncSta=${IncSta}&VehId=${0}&MVehId=${0}&VehSta=${false}&isNew=${true}`)
            } else {
                navigate(`/Vehicle-Home?IncId=${stringToBase64(IncID)}&IncNo=${IncNo}&IncSta=${IncSta}&VehId=${0}&MVehId=${0}&VehSta=${false}&isNew=${true}`)
            }
            reset(); setPossessionID(''); setOwnerOfID(''); setPossenSinglData([]);
            setClickedRow(null); setVehicleStatus(false);
            setStatus(false); get_vehicle_Count(''); PropertyType(loginAgencyID);
            setVehicleMultiImg([]); setuploadImgFiles([]);

            dispatch({ type: Master_Vehicle_Status, payload: false });
        }
        setPropertyStatus(false);
    }

    const OnClose = () => {
        setStatesChangeStatus(false);
        if (MstVehicle === 'MST-Vehicle-Dash') {
            if (isCADSearch) {
                navigate('/cad/dashboard-page');
            } else {
                navigate('/dashboard-page');
            }
        }
    }

    const isFormReadOnly = isFormViewOnly;
    const disableVehicleFieldsForLossCode = isLossCodeNoneOrUnknown;

    const matchingVehicleCategoryOffenseTooltipRules = useMemo(() => {
        if (!value?.CategoryID || !categoryCode || !Array.isArray(nibrsCodeArr)) return [];
        const selectedCategoryCode = String(categoryCode);

        return VEHICLE_CATEGORY_OFFENSE_TOOLTIP_RULES.filter(({ offenses, categoryCodes }) =>
            offenses.some((offenseCode) => nibrsCodeArr.includes(offenseCode)) &&
            categoryCodes.includes(selectedCategoryCode)
        );
    }, [categoryCode, nibrsCodeArr, value?.CategoryID]);

    const getPlateStateStyle = () => {
        if (disableVehicleFieldsForLossCode) return selectBoxDiableColourStyles;
        return categoryCode === "NMVs" || plateTypeCode === "Unknown" ? WidhoutColorStyles : Requiredcolour
    }

    const getPlateTypeOption = (arr) => {
        if (categoryCode === "NMVs") {
            return arr?.filter((item) => item.id === "Unknown")
        } else {
            return arr
        }
    }

    const GetSingleDataPassion = (nameID, masterNameID) => {
        const val = { 'NameID': nameID, 'MasterNameID': masterNameID }
        fetchPostData('MasterName/GetSingleData_MasterName', val).then((res) => {
            if (res) {
                setPossenSinglData(res);
            } else { setPossenSinglData([]); }
        })
    }

    // PropertyVehicleManager: after Release to Owner modal save — update Owner in form and persist to vehicle via API
    useEffect(() => {
        if (!isPropertyEvidence || !releaseSyncedOwner?.revision) return;
        const oid = releaseSyncedOwner.ownerID;

        if (oid === null || oid === undefined || oid === '') return;
        if (selectedIncidentID && effectiveIncidentID) {
            setValue((prev) => ({ ...prev, OwnerID: oid }));
            setOwnerOfID(typeof oid === 'number' ? oid : parseInt(oid, 10));
            // dispatch(get_Masters_Name_Drp_Data(oid));
            // GetSingleDataPassion(oid, 0);

            const payload = {
                ...value,
                OwnerID: oid,
                ModifiedByUserFK: loginPinID,
                IncidentID: effectiveIncidentID,
                RecoveredPropertyUnderJurisdiction: !!value?.UnderJurisdiction,
            };
            AddDeleteUpadate('PropertyVehicle/Update_PropertyVehicle', payload).then((res) => {
                if (res?.success) {
                    GetSingleData(payload.PropertyID, payload.MasterPropertyID || 0);
                } else {
                    toastifyError('Could not save owner on vehicle. Please try again.');
                }
            }).catch(() => toastifyError('Could not save owner on vehicle.'));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- run only when parent signals release owner sync
    }, [releaseSyncedOwner?.revision, isPropertyEvidence, releaseSyncedOwner]);
    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === 'Escape') {
                setNameModalStatus(false);
            }
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, []);

    const HandleChangesPlate = (e) => {
        const { name, value: inputValue } = e.target;
        !addUpdatePermission && setStatesChangeStatus(true); !addUpdatePermission && setChangesStatus(true);
        // Block if VehicleNo starts with 0
        if (name === 'VehicleNo') {
            if (inputValue.length === 1 && inputValue === '0') {
                return;
            }
            // Remove special characters - allow only alphanumeric characters
            const filteredValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');
            setValue({
                ...value,
                [name]: filteredValue.toUpperCase(),
            });
            return;
        }
        setValue({
            ...value,
            [name]: name === 'VehicleNo' ? inputValue.toUpperCase() : inputValue,
        });
    };

    const getValidDate = (date) => {
        const d = new Date(date);
        return !isNaN(d.getTime()) ? d : null;
    };

    return (
        <>
            {((incidentCount[0]?.VehicleCount === 0 || incidentCount[0]?.VehicleCount === "0") || (VehSta === true || VehSta === 'true') || isNew === "true" || isNew === true || isCaseManagement || isPropertyEvidence) && (
                <>
                    <div className="col-12 col-md-12 col-lg-12 p-0">
                        <div className="col-12 Offense_child">
                            <div className="row align-items-center mt-1" style={{ rowGap: "5px" }}>
                                <div className="col-2 col-md-2 col-lg-1">
                                    <label htmlFor="" className='new-label mb-0'>Vehicle #</label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3 text-field mt-0">
                                    <input style={{ padding: '5px 9px 7px 8px' }} type="text" name='VehicleNumber' id='VehicleNumber' placeholder='Auto Generated' value={value?.VehicleNumber} onChange={HandleChanges} className='readonlyColor h-100' required autoComplete='off' readOnly />
                                </div>

                                <div className="col-2 col-md-2 col-lg-1 d-flex justify-content-end">
                                    <label htmlFor="" className='new-label mb-0 text-right'>Reported Date/Time{errors.ReportedDtTmError !== 'true' ? (
                                        <p style={{ color: 'red', fontSize: '11px', margin: '0px', padding: '0px' }}>{errors.ReportedDtTmError}</p>
                                    ) : null}</label>
                                </div>
                                <div className="col-10 col-md-10 col-lg-3">
                                    {
                                        MstVehicle === 'MST-Vehicle-Dash' ?
                                            <DatePicker
                                                id='reportedDtTm'
                                                name='reportedDtTm'
                                                ref={startRef}
                                                onKeyDown={(e) => {
                                                    if (!((e.key >= '0' && e.key <= '9') || e.key === 'Backspace' || e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Delete' || e.key === ':' || e.key === '/' || e.key === ' ' || e.key === 'F5')) {
                                                        e.preventDefault();
                                                    } else {
                                                        onKeyDown(e);
                                                    }
                                                }}
                                                onChange={(date) => {
                                                    setIncidentReportedDate(date ? getShowingMonthDateYear(date) : null)
                                                    !addUpdatePermission && setChangesStatus(true); !addUpdatePermission && setStatesChangeStatus(true);
                                                    if (date > new Date(datezone)) {
                                                        date = new Date(datezone);
                                                    }
                                                    if (date >= new Date()) {
                                                        setValue({ ...value, ['ReportedDtTm']: new Date() ? getShowingDateText(new Date(date)) : null })
                                                    } else if (date <= new Date(incReportedDate)) {
                                                        setValue({ ...value, ['ReportedDtTm']: new Date() ? getShowingDateText(new Date(date)) : null })
                                                    } else {
                                                        setValue({ ...value, ['ReportedDtTm']: date ? getShowingDateText(date) : null })
                                                    }
                                                }}
                                                dateFormat="MM/dd/yyyy HH:mm"
                                                timeFormat="HH:mm"
                                                is24Hour
                                                isClearable={false}
                                                // selected={value?.ReportedDtTm && new Date(value?.ReportedDtTm)}
                                                selected={getValidDate(value?.ReportedDtTm)}
                                                autoComplete="Off"
                                                timeInputLabel
                                                placeholderText={'Select...'}
                                                showTimeSelect
                                                showYearDropdown
                                                showMonthDropdown
                                                dropdownMode="select"
                                                timeIntervals={1}
                                                timeCaption="Time"
                                                maxDate={new Date(datezone)}
                                                filterTime={(date) => filterPassedTimeZone(date, datezone)}

                                                className={nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.ReportedDtTm, isLocked) ? 'LockFildsColor' : 'requiredColor'}
                                                disabled={nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.ReportedDtTm, isLocked) || isFormReadOnly}
                                            />
                                            :
                                            <DatePicker
                                                id='reportedDtTm'
                                                name='reportedDtTm'
                                                ref={startRef}
                                                onKeyDown={(e) => {
                                                    if (!((e.key >= '0' && e.key <= '9') || e.key === 'Backspace' || e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Delete' || e.key === ':' || e.key === '/' || e.key === ' ' || e.key === 'F5')) {
                                                        e.preventDefault();
                                                    } else {
                                                        onKeyDown(e);
                                                    }
                                                }}
                                                dateFormat="MM/dd/yyyy HH:mm"
                                                timeFormat="HH:mm "
                                                is24Hour
                                                isClearable={false}
                                                // selected={value?.ReportedDtTm && new Date(value?.ReportedDtTm)}
                                                selected={getValidDate(value?.ReportedDtTm)}
                                                autoComplete="Off"
                                                onChange={(date) => {
                                                    setIncidentReportedDate(date ? getShowingMonthDateYear(date) : null);
                                                    !addUpdatePermission && setChangesStatus(true); !addUpdatePermission && setStatesChangeStatus(true);
                                                    if (date > new Date(datezone)) {
                                                        date = new Date(datezone);
                                                    }
                                                    if (date >= new Date()) {
                                                        setValue({ ...value, ['ReportedDtTm']: new Date() ? getShowingDateText(new Date()) : null })
                                                    } else if (date <= new Date(incReportedDate)) {
                                                        setValue({ ...value, ['ReportedDtTm']: incReportedDate ? getShowingDateText(incReportedDate) : null })
                                                    } else {
                                                        setValue({ ...value, ['ReportedDtTm']: date ? getShowingDateText(date) : null })
                                                    }
                                                }}
                                                timeInputLabel
                                                showTimeSelect
                                                timeIntervals={1}
                                                timeCaption="Time"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                minDate={new Date(incReportedDate)}
                                                maxDate={new Date(datezone)}
                                                showDisabledMonthNavigation
                                                filterTime={(date) => filterPassedTimeZonesProperty(date, incReportedDate, datezone)}

                                                // className={nibrsSubmittedvehicleMain === 1 ? 'LockFildsColor' : 'requiredColor'}
                                                // disabled={nibrsSubmittedvehicleMain === 1}
                                                className={nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.ReportedDtTm, isLocked) || isFormReadOnly ? 'LockFildsColor' : 'requiredColor'}
                                                disabled={nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.ReportedDtTm, isLocked) || isFormReadOnly}
                                            />
                                    }
                                </div>
                                <div className="col-2 col-md-2 col-lg-1 ">
                                    <label htmlFor="" className='new-label mb-0'>Loss Code{errors.LossCodeIDError !== 'true' ? (
                                        <p style={{ color: 'red', fontSize: '11px', margin: '0px', padding: '0px' }}>{errors.LossCodeIDError}</p>
                                    ) : null}</label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3" onMouseEnter={() => setIsVehicleLossCodeFieldHovered(true)} onMouseLeave={() => setIsVehicleLossCodeFieldHovered(false)}>
                                    {isVehicleLossCodeFieldHovered && shouldShowUnderJurisdictionRecoverError && value?.UnderJurisdiction && (
                                        <div className="nibrs-tooltip-error nibrs-tooltip-error-bottom" style={{ left: '-190px' }}>
                                            <div className="tooltip-arrow"></div>
                                            <div className="tooltip-content">
                                                <span className="text-danger">⚠️ {'Error: Recovered vehicle must first be reported as stolen when "Under Jurisdiction" is selected, except for offenses 250 - Counterfeiting/Forgery and 280 - Stolen Property Offenses.'}</span>
                                            </div>
                                        </div>
                                    )}
                                    <Select
                                        name='LossCodeID'
                                        value={propertyLossCodeData?.filter((obj) => obj.value === value?.LossCodeID)}
                                        options={propertyLossCodeData}
                                        onChange={(e) => ChangePhoneType(e, 'LossCodeID')}
                                        isClearable
                                        placeholder="Select..."
                                        styles={nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.LossCodeID, isLocked) || isFormReadOnly ? LockFildscolour : Requiredcolour}
                                        isDisabled={nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.LossCodeID, isLocked) || isFormReadOnly ? true : false}
                                    />
                                    {errors.RecoveredVehicleDataError !== 'true' && errors.RecoveredVehicleDataError !== '' ? (
                                        <p style={{ color: 'red', fontSize: '11px', margin: '0px', padding: '2px 0 0 0' }}>{errors.RecoveredVehicleDataError}</p>
                                    ) : null}
                                </div>
                                {isRecoveredOrStolenLossCode(value?.LossCodeID) && (
                                    <div className="col-12 col-md-12 col-lg-12 offset-9 px-1 d-flex align-items-center mt-1" style={{ gap: '10px' }}>
                                        <div className="form-check d-flex align-items-center">
                                            <input
                                                className="form-check-input"
                                                name='UnderJurisdiction'
                                                value={value?.UnderJurisdiction}
                                                onChange={HandleChanges}
                                                checked={value?.UnderJurisdiction}
                                                type="checkbox"
                                                id="underJurisdictionVehicleCheckbox"
                                                disabled={isStolenLossCode(value?.LossCodeID) || isLockOrRestrictModule("Lock", editval[0]?.UnderJurisdiction, isLocked) || nibrsSubmittedvehicleMain === 1 || isFormReadOnly || (errors.RecoveredVehicleDataError !== 'true' && errors.RecoveredVehicleDataError !== '') ? true : false}
                                            />
                                            <label htmlFor="underJurisdictionVehicleCheckbox" className='form-check-label ms-2 w-100'>
                                                Under Jurisdiction
                                            </label>
                                        </div>
                                        {errors.UnderJurisdictionError !== 'true' ? (
                                            <p style={{ color: 'red', fontSize: '12px', margin: '0px', padding: '0px', whiteSpace: 'wrap' }}>{errors.UnderJurisdictionError}</p>
                                        ) : null}
                                    </div>
                                )}
                                <div className="col-2 col-md-2 col-lg-1">
                                    <label className='label-name mb-0'>
                                        <span data-toggle="modal" data-target="#ListModel" className='new-link' style={{ float: 'none' }} onClick={() => { setOpenPage('Property Vehicle Plate Type') }}>
                                            Plate Type
                                        </span>
                                        {errors.PlateTypeIDError !== 'true' ? (
                                            <p style={{ color: 'red', fontSize: '11px', margin: '0px', padding: '0px' }}>{errors.PlateTypeIDError}</p>
                                        ) : null}
                                    </label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3">
                                    <Select
                                        name='PlateTypeID'
                                        value={plateTypeIdDrp?.filter((obj) => obj.value === value?.PlateTypeID)}
                                        options={plateTypeIdDrp ? getPlateTypeOption(plateTypeIdDrp) : []}
                                        onChange={(e) => ChangeDropDown(e, 'PlateTypeID')}
                                        isClearable
                                        placeholder="Select..."
                                        styles={nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.PlateTypeID, isLocked) ? LockFildscolour : (disableVehicleFieldsForLossCode || isFormReadOnly) ? selectBoxDiableColourStyles : Requiredcolour}
                                        isDisabled={nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.PlateTypeID, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode ? true : false}
                                    />
                                </div>
                                <div className="col-2 col-md-2 col-lg-1 d-flex justify-content-end">
                                    <label htmlFor="" className='new-label mb-0 text-right' style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
                                        Plate State & No.
                                        {errors.PlateStateNoError !== 'true' ? (
                                            <p style={{ color: 'red', fontSize: '11px', margin: '0px', }}>{errors.PlateStateNoError}</p>
                                        ) : null}
                                    </label>
                                </div>
                                <div className="col-10 col-md-10 col-lg-3 d-flex align-items-center">
                                    <div className="col-6 col-md-6 col-lg-6">
                                        <Select
                                            name='PlateID'
                                            value={stateList?.filter((obj) => obj.value === value?.PlateID)}
                                            options={stateList}
                                            onChange={(e) => {
                                                ChangeDropDown(e, 'PlateID');
                                                if (!e) {
                                                    setValue({ ...value, PlateID: null, VehicleNo: '' });
                                                }
                                            }}
                                            // isClearable
                                            placeholder="Select..."
                                            styles={nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.PlateID, isLocked) ? LockFildscolour : (disableVehicleFieldsForLossCode || isFormReadOnly) ? selectBoxDiableColourStyles : getPlateStateStyle()}
                                            isDisabled={nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.PlateID, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode ? true : false}
                                        />
                                    </div>
                                    <span className='flex-grow-1 col-6 col-md-6 col-lg-6' >
                                        <div className="text-field col-12 col-md-12 col-lg-12 mt-0 ">
                                            <input
                                                className={nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.VehicleNo, isLocked) ? 'LockFildsColor' : (disableVehicleFieldsForLossCode || isFormReadOnly) ? 'readonlyColor' : `${value.PlateID ? "requiredColor" : ""} ${!value?.PlateID ? "readonlyColor" : ""}`.trim()}
                                                disabled={!value?.PlateID || nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.VehicleNo, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode}
                                                type="text"
                                                name='VehicleNo'
                                                id='VehicleNo'
                                                maxLength={8}
                                                value={value?.VehicleNo}
                                                onChange={HandleChangesPlate}
                                                required
                                                // placeholder='Number..'
                                                autoComplete='off'
                                                style={{ padding: "5px" }}
                                            />
                                        </div>
                                        {errors.VehicleNoError !== 'true' && value.PlateID ? (
                                            <p style={{ color: 'red', fontSize: '11px', margin: '0px', paddingLeft: '7px' }}>{errors.VehicleNoError}</p>
                                        ) : null}
                                    </span>
                                </div>
                                <div className="col-2 col-md-2 col-lg-1 mt-3">
                                    <label htmlFor="VIN" className='new-label mb-0'>VIN</label>
                                    {errors.vinLengthError && errors.vinLengthError !== 'true' ? (
                                        <p className="mb-0 mt-1" style={{ color: 'red', fontSize: '11px', lineHeight: '1.2' }}>{errors.vinLengthError}</p>
                                    ) : null}
                                </div>
                                <div className="col-10 col-md-10 col-lg-3 d-flex align-items-center">
                                    <div className="text-field flex-grow-1 d-flex align-items-center">
                                        <input type="text" name='VIN' id='VIN' style={{ textTransform: "uppercase", padding: '5px 9px 7px 8px' }} maxLength={17} value={value?.VIN} onChange={HandleChanges} className={isFormReadOnly || disableVehicleFieldsForLossCode ? 'readonlyColor' : ''} required autoComplete='off' disabled={isFormReadOnly || disableVehicleFieldsForLossCode} readOnly={isFormReadOnly || disableVehicleFieldsForLossCode} />
                                        <span className=''>
                                            <span className='col-1 col-md-1 col-lg-1'>
                                                {
                                                    (!vehicleStatus || !masterPropertyID) && (VehSta != 'true' || VehSta != true) &&
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-success"
                                                        data-toggle="modal"
                                                        disabled={isFormReadOnly || disableVehicleFieldsForLossCode}
                                                        data-target="#PropertyModal"
                                                        onClick={() => {
                                                            dispatch(get_Vehicle_Search_Data(
                                                                value?.VIN, value?.VODID, value?.PlateExpireDtTm, value?.OANID, value?.StyleID, value?.PrimaryColorID,
                                                                value?.SecondaryColorID, value?.Value, value?.Inspection_Sticker, value?.InspectionExpiresDtTm,
                                                                value?.IsEvidence, value?.LossCodeID, value?.MakeID, value?.ManufactureYear,
                                                                value?.PlateID, value?.VehicleNo, value?.PlateTypeID, value?.CategoryID, value?.ClassificationID, value?.PrimaryOfficerID,
                                                                loginAgencyID, setSearchModalState
                                                            ));
                                                        }}
                                                    >
                                                        Search
                                                    </button>
                                                }
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-2 col-md-2 col-lg-1">
                                    <label htmlFor="" className='new-label mb-0'> Category {errors.CategoryIDError !== 'true' ? (
                                        <p style={{ color: 'red', fontSize: '11px', margin: '0px', padding: '0px' }}>{errors.CategoryIDError}</p>
                                    ) : null}</label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3" onMouseEnter={() => setIsVehicleCategoryFieldHovered(true)} onMouseLeave={() => setIsVehicleCategoryFieldHovered(false)}>
                                    {isVehicleCategoryFieldHovered && matchingVehicleCategoryOffenseTooltipRules.map((rule) => (
                                        <div className="nibrs-tooltip-error" style={{ left: '-90px' }} key={`${rule.offenses.join('-')}-${rule.message}`}>
                                            <div className="tooltip-arrow"></div>
                                            <div className="tooltip-content">
                                                <span className="text-danger">⚠️ {rule.message}</span>
                                            </div>
                                        </div>
                                    ))}
                                    <Select
                                        name='CategoryID'
                                        value={categoryIdDrp?.filter((obj) => obj.value === value?.CategoryID)}
                                        options={categoryIdDrp}
                                        onChange={(e) => ChangeDropDown(e, 'CategoryID')}
                                        isClearable
                                        placeholder="Select..."

                                        styles={nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.CategoryID, isLocked) ? LockFildscolour : (disableVehicleFieldsForLossCode || isFormReadOnly) ? selectBoxDiableColourStyles : Requiredcolour}
                                        isDisabled={nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.CategoryID, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode ? true : false}
                                    />
                                </div>
                                <div className="col-2 col-md-2 col-lg-1">
                                    <label htmlFor="" className='new-label mb-0'>  <span data-toggle="modal" onClick={() => { setOpenPage('Property Classification') }} data-target="#ListModel" className='new-link' style={{ float: 'none' }}>
                                        Classification</span></label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3">
                                    <Select
                                        name='ClassificationID'
                                        value={classificationID?.filter((obj) => obj.value === value?.ClassificationID)}
                                        options={classificationID}
                                        onChange={(e) => ChangeDropDown(e, 'ClassificationID')}
                                        isClearable
                                        placeholder="Select..."

                                        styles={nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.ClassificationID, isLocked) ? LockFildscolour : (disableVehicleFieldsForLossCode || isFormReadOnly) ? selectBoxDiableColourStyles : customStylesWithOutColor}
                                        isDisabled={!value?.CategoryID || nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.ClassificationID, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode ? true : false}
                                    />
                                </div>
                                <div className="col-2 col-md-2 col-lg-1">
                                    <span data-toggle="modal" data-target="#ListModel" className='new-link ' onClick={() => { setOpenPage('Vehicle VOD') }}>
                                        VOD
                                    </span>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3">
                                    <Select
                                        name='VODID'
                                        value={vodIdData?.filter((obj) => obj.value === value?.VODID)}
                                        options={vodIdData}
                                        onChange={(e) => ChangeDropDown(e, 'VODID')}
                                        isClearable
                                        placeholder="Select..."
                                        styles={isLockOrRestrictModule("Lock", editval[0]?.VODID, isLocked) ? LockFildscolour : (disableVehicleFieldsForLossCode || isFormReadOnly) ? selectBoxDiableColourStyles : customStylesWithOutColor}
                                        isDisabled={isLockOrRestrictModule("Lock", editval[0]?.VODID, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode}
                                    />
                                </div>
                                {/* Row 4: Make | Model | Style */}
                                <div className="col-2 col-md-2 col-lg-1">
                                    <label htmlFor="" data-toggle="modal" data-target="#ListModel" className='new-link mb-0 ' onClick={() => { setOpenPage('Property Vehicle Make') }}>Make</label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3">
                                    <Select
                                        name='MakeID'
                                        value={vehMakeDrpData?.filter((obj) => obj.value === value?.MakeID)}
                                        options={vehMakeDrpData}
                                        onChange={(e) => ChangeDropDown(e, 'MakeID')}
                                        isClearable
                                        className={!value?.CategoryID ? 'readonlyColor' : ''}
                                        placeholder="Select..."
                                        styles={isLockOrRestrictModule("Lock", editval[0]?.MakeID, isLocked) ? LockFildscolour : (disableVehicleFieldsForLossCode || isFormReadOnly || !value?.CategoryID) ? selectBoxDiableColourStyles : customStylesWithOutColor}
                                        isDisabled={isLockOrRestrictModule("Lock", editval[0]?.MakeID, isLocked) || isFormReadOnly ? true : false}
                                    />
                                </div>
                                <div className="col-2 col-md-2 col-lg-1">
                                    <label htmlFor="" data-toggle="modal" data-target="#ListModel" className='new-link mb-0 ' onClick={() => { setOpenPage('Property Vehicle Model') }}>Model</label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3">
                                    <Select
                                        name="ModelID"
                                        isClearable
                                        options={modalIdDrp}
                                        styles={isLockOrRestrictModule("Lock", editval[0]?.ModelID, isLocked) ? LockFildscolour : (disableVehicleFieldsForLossCode || isFormReadOnly || !value?.CategoryID || !value?.MakeID) ? selectBoxDiableColourStyles : customStylesWithOutColor}
                                        isDisabled={isLockOrRestrictModule("Lock", editval[0]?.ModelID, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode || !value?.MakeID}
                                        placeholder="Select or type..."
                                        className={!value?.CategoryID ? 'readonlyColor' : ''}
                                        value={
                                            modalIdDrp?.find((obj) => obj.value?.toString() === value?.ModelID?.toString())
                                            || (value?.ModelName ? { label: value.ModelName, value: value.ModelName } : null)
                                        }
                                        onChange={(e) => ChangeDropDown(e, "ModelID")}
                                    />
                                </div>
                                <div className="col-2 col-md-2 col-lg-1">
                                    <span data-toggle="modal" data-target="#ListModel" className='new-link ' onClick={() => { setOpenPage('Property Vehicle Style') }}>
                                        Style
                                    </span>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3">
                                    <Select
                                        name='StyleID'
                                        value={styleDrp?.filter((obj) => obj.value === value?.StyleID)}
                                        options={styleDrp}
                                        onChange={(e) => ChangeDropDown(e, 'StyleID')}
                                        isClearable
                                        className={!value?.CategoryID ? 'readonlyColor' : ''}
                                        placeholder="Select..."
                                        styles={isLockOrRestrictModule("Lock", editval[0]?.StyleID, isLocked) ? LockFildscolour : (disableVehicleFieldsForLossCode || isFormReadOnly || !value?.CategoryID || !value?.VODID) ? selectBoxDiableColourStyles : customStylesWithOutColor}
                                        isDisabled={isLockOrRestrictModule("Lock", editval[0]?.StyleID, isLocked) || isFormReadOnly || isLockOrRestrictModule("Lock", editval[0]?.VODID, isLocked) ? true : false}
                                    />
                                </div>
                                {/* Row 5: Plate Expiration | Manuf. Year + Weight | OAN ID */}
                                <div className="col-2 col-md-2 col-lg-1 d-flex justify-content-end">
                                    <label htmlFor="" className='new-label mb-0 text-right' style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>Plate Expiration</label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3 d-flex align-items-center">
                                    <DatePicker
                                        selected={
                                            value?.PlateExpirationMonth
                                                ? new Date(2023, value.PlateExpirationMonth - 1)
                                                : null
                                        }
                                        onChange={(date) => {
                                            if (!date) {
                                                setValue(prev => ({ ...prev, PlateExpirationMonth: null }));
                                                return;
                                            }
                                            const selectedMonth = date.getMonth() + 1;
                                            setValue(prev => ({ ...prev, PlateExpirationMonth: selectedMonth }));
                                        }}
                                        openToDate={new Date(2023, new Date().getMonth())}
                                        dateFormat="MMM"
                                        showMonthYearPicker
                                        dropdownMode="select"
                                        autoComplete="off"
                                        maxDate={new Date(2023, 11)}
                                        isClearable
                                        renderCustomHeader={() => null}
                                        className={isLockOrRestrictModule("Lock", editval[0]?.PlateExpirationMonth, isLocked) ? 'LockFildsColor' : (isFormReadOnly || disableVehicleFieldsForLossCode) ? 'readonlyColor' : ''}
                                        disabled={isLockOrRestrictModule("Lock", editval[0]?.PlateExpirationMonth, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode}
                                    />
                                    -
                                    <DatePicker
                                        selected={value?.PlateExpirationYear ? new Date(value.PlateExpirationYear, (value?.PlateExpirationMonth ? value.PlateExpirationMonth - 1 : 0)) : null}
                                        onChange={(date) => {
                                            !addUpdatePermission && setChangesStatus(true);
                                            !addUpdatePermission && setStatesChangeStatus(true);
                                            if (!date) {
                                                setValue(prev => ({ ...prev, PlateExpirationYear: null }));
                                                return;
                                            }
                                            const selectedYear = date.getFullYear();
                                            setValue(prev => ({ ...prev, PlateExpirationYear: selectedYear }));
                                        }}
                                        openToDate={value?.PlateExpirationYear ? new Date(value.PlateExpirationYear, 0) : new Date()}
                                        yearItemNumber={8}
                                        dateFormat="yyyy"
                                        dropdownMode="select"
                                        autoComplete="off"
                                        showYearPicker
                                        isClearable
                                        className={isLockOrRestrictModule("Lock", editval[0]?.PlateExpirationYear, isLocked) ? 'LockFildsColor' : (isFormReadOnly || disableVehicleFieldsForLossCode) ? 'readonlyColor' : ''}
                                        disabled={isLockOrRestrictModule("Lock", editval[0]?.PlateExpirationYear, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode}
                                    />
                                </div>
                                <div className="col-2 col-md-2 col-lg-1 d-flex justify-content-end">
                                    <label htmlFor="" className='new-label mb-0 text-right' style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>Manufacturing Year</label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-1">
                                    <DatePicker
                                        name='ManufactureYear'
                                        id='ManufactureYear'
                                        selected={manufactureDate}
                                        onChange={(date) => {
                                            !addUpdatePermission && setChangesStatus(true); !addUpdatePermission && setStatesChangeStatus(true);
                                            setManufactureDate(date); setValue({ ...value, ['ManufactureYear']: date ? getYearWithOutDateTime(date) : null })
                                        }}
                                        showYearPicker
                                        dateFormat="yyyy"
                                        yearItemNumber={8}
                                        ref={startRef2}
                                        onKeyDown={onKeyDown}
                                        autoComplete="off"
                                        showYearDropdown
                                        showMonthDropdown
                                        dropdownMode="select"
                                        maxDate={new Date()}
                                        minDate={new Date(1900, 0, 1)}
                                        className={isLockOrRestrictModule("Lock", editval[0]?.ManufactureYear, isLocked) ? 'LockFildsColor' : (isFormReadOnly || disableVehicleFieldsForLossCode) ? 'readonlyColor' : ''}
                                        disabled={isLockOrRestrictModule("Lock", editval[0]?.ManufactureYear, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode}
                                    />
                                </div>
                                <div className="col-2 col-md-2 col-lg-1">
                                    <label htmlFor="" className='new-label mb-0'>Weight</label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-1 mt-0 text-field">
                                    <input
                                        style={{ padding: '5px 9px 7px 8px' }}
                                        type="text"
                                        name='Weight'
                                        id='Weight'
                                        maxLength={4}
                                        value={value?.Weight}
                                        onChange={HandleChanges}
                                        required
                                        autoComplete='off'
                                        className={isLockOrRestrictModule("Lock", editval[0]?.Weight, isLocked) ? 'h-100 LockFildsColor' : (isFormReadOnly || disableVehicleFieldsForLossCode) ? 'h-100 readonlyColor' : 'h-100'}
                                        disabled={isLockOrRestrictModule("Lock", editval[0]?.Weight, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode ? true : false}
                                    />
                                </div>
                                <div className="col-2 col-md-2 col-lg-1">
                                    <label htmlFor="" className='new-label mb-0'>OAN ID</label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3 mt-0 text-field ">
                                    <input
                                        style={{ padding: '5px 9px 7px 8px' }}
                                        type="text"
                                        name='OANID'
                                        id='OANID'
                                        value={value?.OANID}
                                        onChange={HandleChanges}
                                        required
                                        maxLength={20}
                                        autoComplete='off'
                                        className={isLockOrRestrictModule("Lock", editval[0]?.OANID, isLocked) ? 'LockFildsColor h-100' : (isFormReadOnly || disableVehicleFieldsForLossCode) ? 'readonlyColor h-100' : ''}
                                        disabled={isLockOrRestrictModule("Lock", editval[0]?.OANID, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode ? true : false}
                                    />
                                </div>
                                {/* Row 6: Primary Color | Secondary Color | Owner [+] */}
                                <div className="col-2 col-md-2 col-lg-1 d-flex justify-content-end">
                                    <span data-toggle="modal" data-target="#ListModel" className='new-link mb-0' style={{ textAlign: 'end', lineHeight: 1.25, wordBreak: 'break-word', whiteSpace: 'normal' }} onClick={() => { setOpenPage('Color') }}>
                                        Primary Color
                                    </span>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3">
                                    <Select
                                        name='PrimaryColorID'
                                        value={isPrimaryDrpData?.filter((obj) => obj.value === value?.PrimaryColorID)}
                                        options={isPrimaryDrpData}
                                        onChange={(e) => ChangeDropDown(e, 'PrimaryColorID')}
                                        isClearable
                                        placeholder="Select..."
                                        styles={isLockOrRestrictModule("Lock", editval[0]?.PrimaryColorID, isLocked) ? LockFildscolour : (disableVehicleFieldsForLossCode || isFormReadOnly) ? selectBoxDiableColourStyles : customStylesWithOutColor}
                                        isDisabled={isLockOrRestrictModule("Lock", editval[0]?.PrimaryColorID, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode}
                                    />
                                </div>
                                <div className="col-2 col-md-2 col-lg-1 d-flex justify-content-end">
                                    <span data-toggle="modal" data-target="#ListModel" className='new-link mb-0' style={{ textAlign: 'end', lineHeight: 1.25, wordBreak: 'break-word', whiteSpace: 'normal' }} onClick={() => { setOpenPage('Color') }}>
                                        Secondary Color
                                    </span>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3">
                                    <Select
                                        name='SecondaryColorID'
                                        value={isSecondaryDrpData?.filter((obj) => obj.value === value?.SecondaryColorID)}
                                        options={isSecondaryDrpData}
                                        onChange={(e) => ChangeDropDown(e, 'SecondaryColorID')}
                                        isClearable
                                        placeholder="Select..."
                                        styles={isLockOrRestrictModule("Lock", editval[0]?.SecondaryColorID, isLocked) ? LockFildscolour : (disableVehicleFieldsForLossCode || isFormReadOnly) ? selectBoxDiableColourStyles : customStylesWithOutColor}
                                        isDisabled={isLockOrRestrictModule("Lock", editval[0]?.SecondaryColorID, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode}
                                    />
                                </div>
                                <div className="col-2 col-md-2 col-lg-1">
                                    <label htmlFor="" className='new-label mb-0'>Owner</label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-2">
                                    {
                                        MstVehicle === "MST-Vehicle-Dash" ?
                                            <>
                                                <Select
                                                    name='OwnerID'
                                                    value={mastersNameDrpData?.filter((obj) => obj.value === value?.OwnerID)}
                                                    options={mastersNameDrpData}
                                                    onChange={(e) => { onInProfessionChange(e, 'OwnerID') }}
                                                    isClearable
                                                    placeholder="Select..."
                                                    styles={isLockOrRestrictModule("Lock", editval[0]?.OwnerID, isLocked) ? LockFildscolour : (isFormReadOnly || disableVehicleFieldsForLossCode) ? selectBoxDiableColourStyles : customStylesWithOutColor}
                                                    isDisabled={isLockOrRestrictModule("Lock", editval[0]?.OwnerID, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode}
                                                />
                                            </>
                                            :
                                            <>
                                                <Select
                                                    name='OwnerID'
                                                    value={arresteeNameVehicle?.filter((obj) => obj.value === value?.OwnerID)}
                                                    options={arresteeNameVehicle}
                                                    onChange={(e) => { onInProfessionChange(e, 'OwnerID') }}
                                                    isClearable
                                                    placeholder="Select..."
                                                    styles={isLockOrRestrictModule("Lock", editval[0]?.OwnerID, isLocked) ? LockFildscolour : (isFormReadOnly || disableVehicleFieldsForLossCode) ? selectBoxDiableColourStyles : customStylesWithOutColor}
                                                    isDisabled={isLockOrRestrictModule("Lock", editval[0]?.OwnerID, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode}
                                                />
                                            </>
                                    }
                                </div>
                                <div className="col-6 col-md-6 col-lg-1" >
                                    <button
                                        onClick={() => {
                                            if (ownerOfID) {
                                                setTimeout(() => {
                                                    GetSingleDataPassion(ownerOfID, 0);
                                                }, [200])
                                            }
                                            setNameModalStatus(true);
                                            setType("VehicleOwner");
                                            setPossenSinglData([]);
                                            get_Name_Count(ownerOfID);
                                            get_vehicle_Count(vehicleID);
                                        }}
                                        disabled={isFormReadOnly || disableVehicleFieldsForLossCode}
                                        className="btn btn-sm bg-green text-white" data-toggle="modal" data-target="#MasterModal">
                                        <i className="fa fa-plus"></i>
                                    </button>
                                </div>
                                {/* Row 7: Inspection Sticker | Inspection Expires | Value */}
                                <div className="col-2 col-md-2 col-lg-1 d-flex justify-content-end">
                                    <label htmlFor="" className='new-label mb-0 text-right' style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>Inspection Sticker</label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3 mt-0 text-field ">
                                    <input style={{ padding: '5px 9px 7px 8px' }} type="text" name='Inspection_Sticker' id='Inspection_Sticker' value={value?.Inspection_Sticker} onChange={HandleChanges} className={`h-100 ${(isFormReadOnly || disableVehicleFieldsForLossCode) ? 'readonlyColor' : ''}`} required autoComplete='off' disabled={isFormReadOnly || disableVehicleFieldsForLossCode} readOnly={isFormReadOnly || disableVehicleFieldsForLossCode} />
                                </div>
                                <div className="col-2 col-md-2 col-lg-1 text-right">
                                    <label htmlFor="" className='new-label mb-0' style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>Inspection Expires</label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3">
                                    <DatePicker
                                        id='InspectionExpiresDtTm'
                                        name='InspectionExpiresDtTm'
                                        ref={startRef1}
                                        onKeyDown={(e) => {
                                            if (!((e.key >= '0' && e.key <= '9') || e.key === 'Backspace' || e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Delete' || e.key === ':' || e.key === '/' || e.key === ' ' || e.key === 'F5')) {
                                                e.preventDefault();
                                            } else {
                                                onKeyDown(e);
                                            }
                                        }}
                                        onChange={(date) => {
                                            // date will be null if cleared, or valid date if selected
                                            !addUpdatePermission && setChangesStatus(true);
                                            !addUpdatePermission && setStatesChangeStatus(true);
                                            setInspectionExpDate(date);
                                            setValue({ ...value, ['InspectionExpiresDtTm']: date ? getShowingMonthDateYear(date) : null });
                                        }}
                                        onChangeRaw={(e) => {
                                            const input = e.target.value?.trim();

                                            if (input === '') {
                                                // User cleared the field
                                                setInspectionExpDate(null);
                                                setValue({ ...value, ['InspectionExpiresDtTm']: null });
                                            } else {
                                                const parsedDate = new Date(input);
                                                if (isNaN(parsedDate?.getTime())) {
                                                    // Invalid input, set current date
                                                    const now = new Date();
                                                    setInspectionExpDate(now);
                                                    setValue({ ...value, ['InspectionExpiresDtTm']: getShowingMonthDateYear(now) });
                                                }
                                                // Else valid input will be handled by onChange
                                            }
                                        }}
                                        dateFormat="MM/dd/yyyy"
                                        isClearable={!!value?.inspectionExpDate}
                                        selected={inspectionExpDate}
                                        placeholderText={value?.inspectionExpDate || 'Select...'}
                                        autoComplete="off"
                                        showYearDropdown
                                        showMonthDropdown
                                        dropdownMode="select"

                                        className={isLockOrRestrictModule("Lock", editval[0]?.InspectionExpiresDtTm, isLocked) ? 'LockFildsColor' : (isFormReadOnly || disableVehicleFieldsForLossCode) ? 'readonlyColor' : ''}
                                        disabled={isLockOrRestrictModule("Lock", editval[0]?.InspectionExpiresDtTm, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode}

                                    />
                                </div>
                                <div className="col-2 col-md-2 col-lg-1">
                                    <label htmlFor="" className='new-label mb-0'>Value
                                        {errors.ContactError !== 'true' ? (
                                            <p style={{ color: 'red', fontSize: '11px', margin: '0px', padding: '0px' }}>{errors.ContactError}</p>
                                        ) : null}
                                    </label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3 mt-0 text-field">
                                    <input
                                        style={{ padding: '5px 9px 7px 8px' }}
                                        type="text"
                                        name="Value"
                                        id="Value"
                                        className={`h-100 ${nibrsSubmittedvehicleMain === 1 || isLockOrRestrictModule("Lock", editval[0]?.Value, isLocked) ? 'LockFildsColor' : disableVehicleFieldsForLossCode ? 'readonlyColor' : !value?.CategoryID ? 'readonlyColor' : (lossCode === 'STOL' || lossCode === 'BURN' || lossCode === 'RECD') ? 'requiredColor' : ''}`}
                                        disabled={nibrsSubmittedvehicleMain === 1 || !value?.CategoryID || isLockOrRestrictModule("Lock", editval[0]?.Value, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode ? true : false}
                                        maxLength={9}
                                        value={`$ ${value?.Value}`}
                                        onChange={HandleChanges}
                                        required
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="col-2 col-md-2 col-lg-1 d-flex justify-content-end">
                                    <label htmlFor="" className='new-label mb-0 text-right' style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>Primary Officer</label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3">
                                    <Select
                                        name='PrimaryOfficerID'
                                        value={primaryOfficerID?.filter((obj) => obj.value == value?.PrimaryOfficerID)}
                                        options={primaryOfficerID}
                                        onChange={(e) => ChangeDropDown(e, 'PrimaryOfficerID')}
                                        isClearable
                                        placeholder="Select..."

                                        styles={isLockOrRestrictModule("Lock", editval[0]?.PrimaryOfficerID, isLocked) ? LockFildscolour : (isFormReadOnly || disableVehicleFieldsForLossCode) ? selectBoxDiableColourStyles : customStylesWithOutColor}
                                        isDisabled={isLockOrRestrictModule("Lock", editval[0]?.PrimaryOfficerID, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode}
                                    />
                                </div>
                                <div className="col-2 col-md-2 col-lg-1 d-flex justify-content-end">
                                    <label htmlFor="" className='new-label mb-0 text-right' style={{ lineHeight: 1.25, wordBreak: 'break-word', whiteSpace: 'normal' }}>In Possession Of</label>
                                </div>
                                <div className="col-4 col-md-4 col-lg-3 d-flex align-items-center" style={{ gap: '6px' }}>
                                    {
                                        MstVehicle ?
                                            <>
                                                <Select
                                                    name='InProfessionOf'
                                                    value={ownerPossessionDrpData?.filter((obj) => obj.value == value?.InProfessionOf)}
                                                    options={ownerPossessionDrpData}
                                                    onChange={(e) => { onInProfessionChange(e, 'InProfessionOf') }}
                                                    isClearable
                                                    className='w-100'
                                                    placeholder="Select..."
                                                    styles={isLockOrRestrictModule("Lock", editval[0]?.InProfessionOf, isLocked) ? LockFildscolour : (isFormReadOnly || disableVehicleFieldsForLossCode) ? selectBoxDiableColourStyles : customStylesWithOutColor}
                                                    isDisabled={isLockOrRestrictModule("Lock", editval[0]?.InProfessionOf, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode}
                                                />
                                            </>
                                            :
                                            <>
                                                <Select
                                                    name='InProfessionOf'
                                                    value={inProfessionOf?.filter((obj) => obj.value == value?.InProfessionOf)}
                                                    options={inProfessionOf}
                                                    onChange={(e) => { onInProfessionChange(e, 'InProfessionOf') }}
                                                    isClearable
                                                    placeholder="Select..."
                                                    className='w-100'
                                                    styles={isLockOrRestrictModule("Lock", editval[0]?.InProfessionOf, isLocked) ? LockFildscolour : (isFormReadOnly || disableVehicleFieldsForLossCode) ? selectBoxDiableColourStyles : customStylesWithOutColor}
                                                    isDisabled={isLockOrRestrictModule("Lock", editval[0]?.InProfessionOf, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode}
                                                />
                                            </>
                                    }
                                    <button
                                        onClick={() => {
                                            if (possessionID) {
                                                setTimeout(() => {
                                                    GetSingleDataPassion(possessionID, 0);
                                                }, [200])

                                            }
                                            // setOwnerOfID();
                                            setPossenSinglData([]);
                                            setNameModalStatus(true);
                                            setType("VehicleName");
                                        }}
                                        disabled={isFormReadOnly || disableVehicleFieldsForLossCode}
                                        className="btn btn-sm bg-green text-white" data-toggle="modal" data-target="#MasterModal">
                                        <i className="fa fa-plus"></i>
                                    </button>
                                </div>


                                <div className='col-12 mb-md-5 mb-sm-5 mb-lg-0'>
                                    <div className='row align-items-center'>
                                        <div className="col-4 col-md-4 col-lg-1"></div>
                                        <div className="col-6 col-md-4 col-lg-2">
                                            <div className="form-check">
                                                <input className="form-check-input" name='IsEvidence' value={value?.IsEvidence} checked={value?.IsEvidence} onChange={HandleChanges} type="checkbox" id="IsEvidence" disabled={isFormReadOnly || disableVehicleFieldsForLossCode} />
                                                <label className="form-check-label" htmlFor="IsEvidence">
                                                    Evidence
                                                </label>
                                            </div>
                                        </div>
                                        {/* <div className="col-4 col-md-4 col-lg-2 ml-2">
                                            <div className="form-check ">
                                                <input className="form-check-input" name='IsSendToPropertyRoom' value={value?.IsSendToPropertyRoom} checked={value?.IsSendToPropertyRoom} onChange={HandleChanges} type="checkbox" id="flexCheckDefault" disabled={editval[0]?.IsSendToPropertyRoom ? true : isFormReadOnly} />
                                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                                    Send To Property Room
                                                </label>
                                            </div>
                                        </div> */}
                                        <div className="col-4 col-md-4 col-lg-2 ml-2">
                                            <div className="form-check ">
                                                <input className="form-check-input" name='IsVehicleImpound' checked={!!value?.IsVehicleImpound} onChange={HandleChanges} type="checkbox" id="IsVehicleImpound" disabled={isFormReadOnly || disableVehicleFieldsForLossCode} />
                                                <label className="form-check-label" htmlFor="IsVehicleImpound">
                                                    Vehicle Impound
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-3">
                                            <div className="form-check">
                                                <input className="form-check-input" name='IsImmobalizationDevice' value={value?.IsImmobalizationDevice} checked={value?.IsImmobalizationDevice} onChange={HandleChanges} type="checkbox" id="IsImmobalizationDevice" disabled={isFormReadOnly || disableVehicleFieldsForLossCode} />
                                                <label className="form-check-label" htmlFor="IsImmobalizationDevice">
                                                    Immobilization Device
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-3">
                                            <div className="form-check">
                                                <input className="form-check-input" name='IsEligibleForImmobalization' value={value?.IsEligibleForImmobalization} checked={value?.IsEligibleForImmobalization} onChange={HandleChanges} type="checkbox" id="IsEligibleForImmobalization" disabled={isFormReadOnly || disableVehicleFieldsForLossCode} />
                                                <label className="form-check-label" htmlFor="IsEligibleForImmobalization">
                                                    Eligible for Immobilization
                                                </label>
                                            </div>
                                        </div>
                                        {/* {showVehicleRecovered && (
                                            <div className="col-6 col-md-4 col-lg-2">
                                                <div className="form-check">
                                                    <input className="form-check-input" name='IsRecoveredByAgencyOfOther' value={value?.IsRecoveredByAgencyOfOther} checked={value?.IsRecoveredByAgencyOfOther} onChange={HandleChanges} type="checkbox" id="IsRecoveredByAgencyOfOther" />
                                                    <label className="form-check-label" htmlFor="IsRecoveredByAgencyOfOther">
                                                        Is Stolen From Other Agency
                                                    </label>
                                                </div>
                                            </div>
                                        )} */}
                                    </div>
                                </div>
                                <div className='d-flex justify-content-between align-items-center w-100'>
                                    <div className="col-11">
                                        <fieldset className="border-bottom border-right border-left">
                                            <legend>Miscellaneous Information</legend>
                                            <div className="row">
                                                <div className="col-2 col-md-2 col-lg-1 mt-3 ">
                                                    <label htmlFor="" className="new-label">
                                                        Tag #
                                                    </label>
                                                </div>
                                                <div className="col-10 col-md-10 col-lg-2 text-field mt-2">
                                                    <input
                                                        type="text"
                                                        name="TagID"
                                                        id="TagID"
                                                        value={value?.TagID}
                                                        onChange={HandleChanges}
                                                        required
                                                        readOnly
                                                        className={isLockOrRestrictModule("Lock", editval[0]?.TagID, isLocked) ? "LockFildsColor" : "readonlyColor"}
                                                        disabled={isLockOrRestrictModule("Lock", editval[0]?.TagID, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode ? true : false}
                                                    />
                                                </div>
                                                <div className="col-2 col-md-2 col-lg-2 mt-2">
                                                    <label htmlFor="" className="new-label">
                                                        NICB #
                                                    </label>
                                                </div>
                                                <div className="col-10 col-md-10 col-lg-3 text-field mt-1">
                                                    <input
                                                        type="text"
                                                        name="NICBIDID"
                                                        id="NICBIDID"
                                                        value={value?.NICBIDID}
                                                        onChange={HandleChanges}
                                                        required
                                                        readOnly

                                                        className={isLockOrRestrictModule("Lock", editval[0]?.NICBIDID, isLocked) ? "LockFildsColor" : "readonlyColor"}
                                                        disabled={isLockOrRestrictModule("Lock", editval[0]?.NICBIDID, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode ? true : false}
                                                    />
                                                </div>

                                                <div className="col-2 col-md-2 col-lg-1 d-flex justify-content-end mt-2">
                                                    <label htmlFor="" className="new-label mb-0 text-right" style={{ lineHeight: 1.25, wordBreak: 'break-word', whiteSpace: 'normal' }}>
                                                        Destroy Date
                                                    </label>
                                                </div>
                                                <div className="col-lg-3 mt-1">
                                                    <DatePicker
                                                        id="DestroyDtTm"
                                                        name="DestroyDtTm"
                                                        onChange={(date) => {
                                                            !addUpdatePermission && setStatesChangeStatus(true);
                                                            !addUpdatePermission && setChangesStatus(true);
                                                            setValue({
                                                                ...value,
                                                                ["DestroyDtTm"]: date
                                                                    ? getShowingMonthDateYear(date)
                                                                    : null,
                                                            });
                                                        }}
                                                        dateFormat="MM/dd/yyyy HH:mm"
                                                        timeInputLabel
                                                        isClearable={value?.DestroyDtTm ? true : false}
                                                        selected={value?.DestroyDtTm && new Date(value?.DestroyDtTm)}
                                                        placeholderText={
                                                            value?.DestroyDtTm ? value.DestroyDtTm : "Select..."
                                                        }
                                                        showTimeSelect
                                                        timeIntervals={1}
                                                        timeCaption="Time"
                                                        readOnly
                                                        required
                                                        autoComplete="nope"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        dropdownMode="select"

                                                        className={isLockOrRestrictModule("Lock", editval[0]?.DestroyDtTm, isLocked) ? "LockFildsColor" : (isFormReadOnly || disableVehicleFieldsForLossCode) ? "readonlyColor" : "readonlyColor"}
                                                        disabled={isLockOrRestrictModule("Lock", editval[0]?.DestroyDtTm, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode ? true : false}
                                                    />
                                                </div>
                                                <div className="col-1 mt-2">
                                                    <label htmlFor="" className="new-label">
                                                        Description
                                                    </label>
                                                </div>
                                                <div className="col-8 col-md-11 ">
                                                    <textarea
                                                        name="Description"
                                                        id="Description"
                                                        maxLength={250}
                                                        value={value?.Description}
                                                        onChange={HandleChanges}
                                                        cols="30"
                                                        rows="1"
                                                        // className="form-control"

                                                        className={isLockOrRestrictModule("Lock", editval[0]?.Description, isLocked) ? "form-control LockFildsColor" : (isFormReadOnly || disableVehicleFieldsForLossCode) ? "form-control readonlyColor" : "form-control"}
                                                        disabled={isLockOrRestrictModule("Lock", editval[0]?.Description, isLocked) || isFormReadOnly || disableVehicleFieldsForLossCode ? true : false}
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                    <div className=" col-1 text-right ">
                                        <div className="img-box">
                                            <Carousel autoPlay={true} className="carousel-style" showArrows={true} showThumbs={false} showStatus={false} >
                                                {
                                                    vehicleMultiImg?.length > 0 ?
                                                        vehicleMultiImg?.map((item) => (
                                                            <div key={item?.PhotoID ? item?.PhotoID : item?.imgID} onClick={() => { setImageModalStatus(true) }} data-toggle="modal" data-target="#ImageModel" className='model-img'>
                                                                <img src={`data:image/png;base64,${item?.Photo}`} style={{ height: '90px' }} />
                                                            </div>
                                                        ))
                                                        :
                                                        <div data-toggle="modal" data-target="#ImageModel" onClick={() => { setImageModalStatus(true) }}>
                                                            <img src={defualtImage} />
                                                        </div>
                                                }
                                            </Carousel>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-11 mb-md-5 mb-sm-5 mb-lg-0'>

                                    <div className='row justify-content-between align-items-center'>
                                        <div>

                                            {/* {
                                                VehicleFilterData?.length > 0 &&
                                                <button
                                                    type="button"
                                                    onClick={() => { nibrsValidateProperty(mainIncidentID, incReportedDate, baseDate, oriNumber) }}
                                                    className="btn btn-sm mr-2"
                                                    style={{
                                                        backgroundColor: `${nibrsValidateData?.length > 0 ? nibrsValidateData?.length > 0 ? 'red' : 'green' : 'teal'}`,
                                                        color: 'white'
                                                    }}
                                                >
                                                    Validate TIBRS Vehicle
                                                </button>
                                            } */}
                                        </div>


                                        {!isPropertyEvidence && <div>
                                            {vehicleStatus && (VehSta === 'true' || VehSta === true) &&
                                                <button type="button" className="btn btn-sm btn-success mr-1" onClick={() => { setPrintStatus(true) }}>Print Barcode</button>
                                            }
                                            <button type="button" className="btn btn-sm btn-success mr-1" data-toggle="modal" data-target="#NCICModal" onClick={() => { setOpenNCICModal(true) }}>TLETS</button>

                                            {/* <button type="button" className="btn btn-sm btn-success mr-1" onClick={newVehicle}>New</button> */}
                                            {
                                                MstVehicle === "MST-Vehicle-Dash" &&
                                                <button type="button" className="btn btn-sm btn-success mr-1" onClick={() => { newVehicle(); setIsLocked(false) }}>New</button>
                                            }

                                            {
                                                vehicleStatus && (VehSta === 'true' || VehSta === true) ?
                                                    effectiveScreenPermission ?
                                                        effectiveScreenPermission[0]?.Changeok ?
                                                            <>
                                                                <button type="button" disabled={!statesChangeStatus} className="btn btn-sm btn-success  mr-1" onClick={(e) => { check_Validation_Error(); }}>Update</button>
                                                                <button
                                                                    type="button" className="btn btn-sm btn-success mr-4" data-toggle="modal" data-target="#QueueReportsModal"
                                                                    onClick={() => { setShowModal(true); setPrintVehReport(true); setVehReportCount(VehReportCount + 1); }}
                                                                >
                                                                    Print <i className="fa fa-print"></i>
                                                                </button>
                                                            </>

                                                            :
                                                            <>
                                                            </>
                                                        :
                                                        <>
                                                            <button type="button" disabled={!statesChangeStatus} className="btn btn-sm btn-success  mr-1" onClick={(e) => { check_Validation_Error(); }}>Update</button>
                                                            <button
                                                                type="button" className="btn btn-sm btn-success mr-4" data-toggle="modal" data-target="#QueueReportsModal"
                                                                onClick={() => { setShowModal(true); setPrintVehReport(true); setVehReportCount(VehReportCount + 1); }}
                                                            >
                                                                Print <i className="fa fa-print"></i>
                                                            </button>
                                                        </>
                                                    :
                                                    effectiveScreenPermission ?
                                                        effectiveScreenPermission[0]?.AddOK ?
                                                            <button type="button" className="btn btn-sm btn-success  mr-1" onClick={(e) => { setMasterPropertyID(''); check_Validation_Error(); }}>Save</button>
                                                            :
                                                            <>
                                                            </>
                                                        :
                                                        <button type="button" className="btn btn-sm btn-success  mr-1" onClick={(e) => { setMasterPropertyID(''); check_Validation_Error(); }}>Save</button>
                                            }
                                            {
                                                MstVehicle === 'MST-Vehicle-Dash' &&
                                                <button type="button" className="btn btn-sm btn-success " onClick={OnClose}>Close</button>
                                            }
                                        </div>}
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div className="col-12 col-md-12 col-lg-12 p-0 pt-1">
                            <div className=" col-12 modal-table">
                                {/* {
                            MstVehicle != 'MST-Vehicle-Dash' &&
                            <DataTable
                                dense
                                columns={columns}
                                data={effectiveScreenPermission ? effectiveScreenPermission[0]?.DisplayOK ? VehicleFilterData : [] : VehicleFilterData}
                                selectableRowsHighlight
                                highlightOnHover
                                responsive
                                fixedHeaderScrollHeight="150px"
                                fixedHeader
                                persistTableHead={true}
                                customStyles={tableCustomStyle}
                                onRowClicked={(row) => {
                                    setClickedRow(row);
                                    setEditVal(row);
                                }}
                                pagination
                                paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                paginationPerPage={5}
                                conditionalRowStyles={conditionalRowStyles}
                                showHeader={true}

                                noDataComponent={effectiveScreenPermission ? effectiveScreenPermission[0]?.DisplayOK ? "There are no data to display" : "You don’t have permission to view data" : 'There are no data to display'}
                            />
                        } */}
                            </div>
                        </div>
                    </div>
                    {/* <IdentifyFieldColor /> */}
                    {/* <DeletePopUpModal func={delete_Vehicle_Property} /> */}
                    <ChangesModal func={check_Validation_Error} />
                    <ListModal {...{ openPage, setOpenPage }} />
                    <VehicleSearchTab {...{ GetSingleData, searchModalState, setSearchModalState, mainIncidentID, value, setValue, loginPinID, loginAgencyID, MstVehicle, setEditval, setStatesChangeStatus, setChangesStatus, isCad, get_Vehicle_MultiImage }} />
                    <MasterNameModel {...{ value, setValue, nameModalStatus, setNameModalStatus, loginPinID, loginAgencyID, type, setPossessionID, possenSinglData, possessionID, setOwnerOfID, ownerOfID, setPossenSinglData, GetSingleDataPassion }} />
                    <ImageModel multiImage={vehicleMultiImg} pinID={imageModalOfficerID ? imageModalOfficerID : loginPinID} entityID={value?.VehicleNo} newClicked={newClicked} setStatesChangeStatus={setStatesChangeStatus} primaryOfficerID={primaryOfficerID} setMultiImage={setVehicleMultiImg} uploadImgFiles={uploadImgFiles} setuploadImgFiles={setuploadImgFiles} ChangeDropDown={ChangeDropDown} modalStatus={modalStatus} setModalStatus={setModalStatus} imageId={imageId} setImageId={setImageId} imageModalStatus={imageModalStatus} setImageModalStatus={setImageModalStatus} delete_Image_File={delete_Image_File} setImgData={setImgData} imgData={imgData} updateImage={update_Vehicle_MultiImage} agencyID={loginAgencyID} />
                    <AlertMasterModel masterID={masterPropertyID} setStatesChangeVich={setStatesChangeStatus} AlertType={"Vehicle"} modelName={"Vehicle"} loginPinID={loginPinID} agencyID={loginAgencyID} getAlertData={setAvailableAlert} />
                    <BarCode agencyID={loginAgencyID} propID={DecVehId} masPropID={DecMVehId} codeNo={value?.VehicleNumber} printStatus={printStatus} setPrintStatus={setPrintStatus} isVehicle />
                    <NirbsErrorShowModal
                        ErrorText={nibrsErrStr}
                        nibErrModalStatus={nibrsErrModalStatus}
                        setNibrsErrModalStatus={setNibrsErrModalStatus}
                    />
                    <CurrentVehicleReport VehNumber={value.VehicleNumber} {...{ printVehReport, setPrintVehReport, VehReportCount, setVehReportCount, showModal, setShowModal }} />
                    <NCICModal {...{ openNCICModal, setOpenNCICModal, }} vehicleIncidentData={value} VehicleID={VehicleIDNCICModal} IncidentID={IncID} />
                    {
                        clickNibloder && (
                            <div className="loader-overlay">
                                <Loader />
                            </div>
                        )
                    }
                </>
            )}

        </>
    )
}

export default Home

const Get_LossCode = (data, dropDownData) => {
    const result = data?.map((sponsor) => (sponsor.LossCodeID))
    const result2 = dropDownData?.map((sponsor) => {
        if (sponsor.value === result[0]) {
            return { value: result[0], label: sponsor.label, id: sponsor.id }
        }
    })
    const val = result2.filter(function (element) {
        return element !== undefined;
    });
    return val[0]?.id
}

const getCategoryCode = (data, dropDownData) => {
    const result = data?.map((sponsor) => (sponsor.CategoryID))
    const result2 = dropDownData?.map((sponsor) => {
        if (sponsor.value === result[0]) {
            return { value: result[0], label: sponsor.label, id: sponsor.id }
        }
    })
    const val = result2.filter(function (element) {
        return element !== undefined;
    });
    return val[0]?.id
}